/*! For license information please see embed.js.LICENSE.txt */
(() => {
    var e, t, n = {
            "../../node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime.js": e => {
                var t = function(e) {
                    "use strict";
                    var t, n = Object.prototype,
                        r = n.hasOwnProperty,
                        o = "function" == typeof Symbol ? Symbol : {},
                        i = o.iterator || "@@iterator",
                        a = o.asyncIterator || "@@asyncIterator",
                        u = o.toStringTag || "@@toStringTag";

                    function c(e, t, n) {
                        return Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t]
                    }
                    try {
                        c({}, "")
                    } catch (e) {
                        c = function(e, t, n) {
                            return e[t] = n
                        }
                    }

                    function s(e, t, n, r) {
                        var o = t && t.prototype instanceof g ? t : g,
                            i = Object.create(o.prototype),
                            a = new I(r || []);
                        return i._invoke = function(e, t, n) {
                            var r = f;
                            return function(o, i) {
                                if (r === p) throw new Error("Generator is already running");
                                if (r === m) {
                                    if ("throw" === o) throw i;
                                    return R()
                                }
                                for (n.method = o, n.arg = i;;) {
                                    var a = n.delegate;
                                    if (a) {
                                        var u = _(a, n);
                                        if (u) {
                                            if (u === h) continue;
                                            return u
                                        }
                                    }
                                    if ("next" === n.method) n.sent = n._sent = n.arg;
                                    else if ("throw" === n.method) {
                                        if (r === f) throw r = m, n.arg;
                                        n.dispatchException(n.arg)
                                    } else "return" === n.method && n.abrupt("return", n.arg);
                                    r = p;
                                    var c = l(e, t, n);
                                    if ("normal" === c.type) {
                                        if (r = n.done ? m : d, c.arg === h) continue;
                                        return {
                                            value: c.arg,
                                            done: n.done
                                        }
                                    }
                                    "throw" === c.type && (r = m, n.method = "throw", n.arg = c.arg)
                                }
                            }
                        }(e, n, a), i
                    }

                    function l(e, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, n)
                            }
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            }
                        }
                    }
                    e.wrap = s;
                    var f = "suspendedStart",
                        d = "suspendedYield",
                        p = "executing",
                        m = "completed",
                        h = {};

                    function g() {}

                    function y() {}

                    function v() {}
                    var b = {};
                    b[i] = function() {
                        return this
                    };
                    var w = Object.getPrototypeOf,
                        O = w && w(w(x([])));
                    O && O !== n && r.call(O, i) && (b = O);
                    var E = v.prototype = g.prototype = Object.create(b);

                    function T(e) {
                        ["next", "throw", "return"].forEach((function(t) {
                            c(e, t, (function(e) {
                                return this._invoke(t, e)
                            }))
                        }))
                    }

                    function S(e, t) {
                        function n(o, i, a, u) {
                            var c = l(e[o], e, i);
                            if ("throw" !== c.type) {
                                var s = c.arg,
                                    f = s.value;
                                return f && "object" == typeof f && r.call(f, "__await") ? t.resolve(f.__await).then((function(e) {
                                    n("next", e, a, u)
                                }), (function(e) {
                                    n("throw", e, a, u)
                                })) : t.resolve(f).then((function(e) {
                                    s.value = e, a(s)
                                }), (function(e) {
                                    return n("throw", e, a, u)
                                }))
                            }
                            u(c.arg)
                        }
                        var o;
                        this._invoke = function(e, r) {
                            function i() {
                                return new t((function(t, o) {
                                    n(e, r, t, o)
                                }))
                            }
                            return o = o ? o.then(i, i) : i()
                        }
                    }

                    function _(e, n) {
                        var r = e.iterator[n.method];
                        if (r === t) {
                            if (n.delegate = null, "throw" === n.method) {
                                if (e.iterator.return && (n.method = "return", n.arg = t, _(e, n), "throw" === n.method)) return h;
                                n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method")
                            }
                            return h
                        }
                        var o = l(r, e.iterator, n.arg);
                        if ("throw" === o.type) return n.method = "throw", n.arg = o.arg, n.delegate = null, h;
                        var i = o.arg;
                        return i ? i.done ? (n[e.resultName] = i.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, h) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, h)
                    }

                    function N(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t)
                    }

                    function A(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t
                    }

                    function I(e) {
                        this.tryEntries = [{
                            tryLoc: "root"
                        }], e.forEach(N, this), this.reset(!0)
                    }

                    function x(e) {
                        if (e) {
                            var n = e[i];
                            if (n) return n.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var o = -1,
                                    a = function n() {
                                        for (; ++o < e.length;)
                                            if (r.call(e, o)) return n.value = e[o], n.done = !1, n;
                                        return n.value = t, n.done = !0, n
                                    };
                                return a.next = a
                            }
                        }
                        return {
                            next: R
                        }
                    }

                    function R() {
                        return {
                            value: t,
                            done: !0
                        }
                    }
                    return y.prototype = E.constructor = v, v.constructor = y, y.displayName = c(v, u, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === y || "GeneratorFunction" === (t.displayName || t.name))
                    }, e.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : (e.__proto__ = v, c(e, u, "GeneratorFunction")), e.prototype = Object.create(E), e
                    }, e.awrap = function(e) {
                        return {
                            __await: e
                        }
                    }, T(S.prototype), S.prototype[a] = function() {
                        return this
                    }, e.AsyncIterator = S, e.async = function(t, n, r, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new S(s(t, n, r, o), i);
                        return e.isGeneratorFunction(n) ? a : a.next().then((function(e) {
                            return e.done ? e.value : a.next()
                        }))
                    }, T(E), c(E, u, "Generator"), E[i] = function() {
                        return this
                    }, E.toString = function() {
                        return "[object Generator]"
                    }, e.keys = function(e) {
                        var t = [];
                        for (var n in e) t.push(n);
                        return t.reverse(),
                            function n() {
                                for (; t.length;) {
                                    var r = t.pop();
                                    if (r in e) return n.value = r, n.done = !1, n
                                }
                                return n.done = !0, n
                            }
                    }, e.values = x, I.prototype = {
                        constructor: I,
                        reset: function(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(A), !e)
                                for (var n in this) "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t)
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval
                        },
                        dispatchException: function(e) {
                            if (this.done) throw e;
                            var n = this;

                            function o(r, o) {
                                return u.type = "throw", u.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o
                            }
                            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                                var a = this.tryEntries[i],
                                    u = a.completion;
                                if ("root" === a.tryLoc) return o("end");
                                if (a.tryLoc <= this.prev) {
                                    var c = r.call(a, "catchLoc"),
                                        s = r.call(a, "finallyLoc");
                                    if (c && s) {
                                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return o(a.finallyLoc)
                                    } else if (c) {
                                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0)
                                    } else {
                                        if (!s) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return o(a.finallyLoc)
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                                var o = this.tryEntries[n];
                                if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                    var i = o;
                                    break
                                }
                            }
                            i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
                            var a = i ? i.completion : {};
                            return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a)
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h
                        },
                        finish: function(e) {
                            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), A(n), h
                            }
                        },
                        catch: function(e) {
                            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e) {
                                    var r = n.completion;
                                    if ("throw" === r.type) {
                                        var o = r.arg;
                                        A(n)
                                    }
                                    return o
                                }
                            }
                            throw new Error("illegal catch attempt")
                        },
                        delegateYield: function(e, n, r) {
                            return this.delegate = {
                                iterator: x(e),
                                resultName: n,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = t), h
                        }
                    }, e
                }(e.exports);
                try {
                    regeneratorRuntime = t
                } catch (e) {
                    Function("r", "regeneratorRuntime = r")(t)
                }
            },
            "../../node_modules/@babel/runtime/regenerator/index.js": (e, t, n) => {
                e.exports = n("../../node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime.js")
            },
            "./src/embed.js": (e, t, n) => {
                "use strict";

                function r(e, t, n, r, o, i, a) {
                    try {
                        var u = e[i](a),
                            c = u.value
                    } catch (e) {
                        return void n(e)
                    }
                    u.done ? t(c) : Promise.resolve(c).then(r, o)
                }

                function o(e) {
                    return function() {
                        var t = this,
                            n = arguments;
                        return new Promise((function(o, i) {
                            var a = e.apply(t, n);

                            function u(e) {
                                r(a, o, i, u, c, "next", e)
                            }

                            function c(e) {
                                r(a, o, i, u, c, "throw", e)
                            }
                            u(void 0)
                        }))
                    }
                }
                var i = n("../../node_modules/@babel/runtime/regenerator/index.js"),
                    a = n.n(i),
                    u = n("../../node_modules/invariant/browser.js"),
                    c = n.n(u);
                const s = function(e) {
                        return "function" == typeof e
                    },
                    l = function(e) {
                        return e
                    },
                    f = function(e) {
                        return null === e
                    };

                function d(e, t, n) {
                    void 0 === t && (t = l), c()(s(t) || f(t), "Expected payloadCreator to be a function, undefined or null");
                    var r = f(t) || t === l ? l : function(e) {
                            for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
                            return e instanceof Error ? e : t.apply(void 0, [e].concat(r))
                        },
                        o = s(n),
                        i = e.toString(),
                        a = function() {
                            var t = r.apply(void 0, arguments),
                                i = {
                                    type: e
                                };
                            return t instanceof Error && (i.error = !0), void 0 !== t && (i.payload = t), o && (i.meta = n.apply(void 0, arguments)), i
                        };
                    return a.toString = function() {
                        return i
                    }, a
                }
                var p = function(e) {
                        return "".concat("PLAYER", "_").concat(e)
                    },
                    m = p("CONSTRUCTED"),
                    h = p("INIT"),
                    g = p("READY"),
                    y = p("RESTORE"),
                    v = (p("SET_CHAPTERS_LIST"), p("NEXT_CHAPTER"), p("PREVIOUS_CHAPTER"), p("SET_CHAPTER"), p("UPDATE_CHAPTER"), p("STEP_FORWARD"), p("STEP_BACKWARDS"), p("SHOW_COMPONENT_INFO")),
                    b = p("SHOW_COMPONENT_SHOW_TITLE"),
                    w = p("SHOW_COMPONENT_EPISODE_TITLE"),
                    O = p("SHOW_COMPONENT_SUBTITLE"),
                    E = p("SHOW_COMPONENT_INFO_POSTER"),
                    T = p("SHOW_COMPONENT_CONTROLS_CHAPTERS"),
                    S = p("SHOW_COMPONENT_CONTROLS_STEPPERS"),
                    _ = p("SHOW_COMPONENT_CONTROLS_BUTTON_LOADING"),
                    N = p("SHOW_COMPONENT_CONTROLS_BUTTON_REPLAY"),
                    A = p("SHOW_COMPONENT_CONTROLS_BUTTON_REMAINING"),
                    I = p("SHOW_COMPONENT_CONTROLS_BUTTON_DURATION"),
                    x = p("SHOW_COMPONENT_CONTROLS_BUTTON_RETRY"),
                    R = p("SHOW_COMPONENT_CONTROLS_BUTTON_PLAYING"),
                    j = p("SHOW_COMPONENT_CONTROLS_BUTTON_PAUSE"),
                    M = p("SHOW_COMPONENT_PROGRESSBAR"),
                    P = p("SHOW_COMPONENT_TAB"),
                    L = p("SHOW_COMPONENT_VOLUME_SLIDER"),
                    C = p("SHOW_COMPONENT_RATE_SLIDER"),
                    k = p("SHOW_COMPONENT_CHANNELS"),
                    D = p("SHOW_COMPONENT_CONTROLS_BUTTON"),
                    H = p("HIDE_COMPONENT_INFO"),
                    F = p("HIDE_COMPONENT_SHOW_TITLE"),
                    z = p("HIDE_COMPONENT_EPISODE_TITLE"),
                    B = p("HIDE_COMPONENT_SUBTITLE"),
                    U = p("HIDE_COMPONENT_INFO_POSTER"),
                    W = p("HIDE_COMPONENT_ERROR"),
                    V = p("HIDE_COMPONENT_CONTROLS_CHAPTERS"),
                    q = p("HIDE_COMPONENT_CONTROLS_STEPPERS"),
                    G = p("HIDE_COMPONENT_CONTROLS_BUTTON"),
                    Y = p("HIDE_COMPONENT_PROGRESSBAR"),
                    K = p("HIDE_COMPONENT_TAB"),
                    X = p("HIDE_COMPONENT_VOLUME_SLIDER"),
                    Q = p("HIDE_COMPONENT_RATE_SLIDER"),
                    $ = p("HIDE_COMPONENT_CHANNELS"),
                    J = p("SHOW_VISIBLE_COMPONENTS_TAB_INFO"),
                    Z = p("SHOW_VISIBLE_COMPONENTS_TAB_CHAPTERS"),
                    ee = p("SHOW_VISIBLE_COMPONENTS_TAB_FILES"),
                    te = p("SHOW_VISIBLE_COMPONENTS_TAB_AUDIO"),
                    ne = p("SHOW_VISIBLE_COMPONENTS_TAB_SHARE"),
                    re = p("SHOW_VISIBLE_COMPONENTS_TAB_TRANSCRIPTS"),
                    oe = (p("SHOW_VISIBLE_COMPONENTS_TAB_PLAYLIST"), p("SHOW_VISIBLE_COMPONENTS_HEADER_POSTER")),
                    ie = p("SHOW_VISIBLE_COMPONENTS_HEADER_TITLE"),
                    ae = p("SHOW_VISIBLE_COMPONENTS_HEADER_EPISODE"),
                    ue = p("SHOW_VISIBLE_COMPONENTS_HEADER_SUBTITLE"),
                    ce = p("SHOW_VISIBLE_COMPONENTS_CONTROLS_STEPPER"),
                    se = p("SHOW_VISIBLE_COMPONENTS_CONTROLS_CHAPTERS"),
                    le = p("SHOW_VISIBLE_COMPONENTS_CONTROLS_PROGRESSBAR"),
                    fe = p("SHOW_SHARE_PLAYTIME"),
                    de = p("HIDE_VISIBLE_COMPONENTS_TAB_INFO"),
                    pe = p("HIDE_VISIBLE_COMPONENTS_TAB_CHAPTERS"),
                    me = p("HIDE_VISIBLE_COMPONENTS_TAB_FILES"),
                    he = p("HIDE_VISIBLE_COMPONENTS_TAB_AUDIO"),
                    ge = p("HIDE_VISIBLE_COMPONENTS_TAB_SHARE"),
                    ye = p("HIDE_VISIBLE_COMPONENTS_TAB_TRANSCRIPTS"),
                    ve = (p("HIDE_VISIBLE_COMPONENTS_TAB_PLAYLIST"), p("HIDE_VISIBLE_COMPONENTS_HEADER_POSTER")),
                    be = p("HIDE_VISIBLE_COMPONENTS_HEADER_TITLE"),
                    we = p("HIDE_VISIBLE_COMPONENTS_HEADER_EPISODE"),
                    Oe = p("HIDE_VISIBLE_COMPONENTS_HEADER_SUBTITLE"),
                    Ee = p("HIDE_VISIBLE_COMPONENTS_CONTROLS_STEPPER"),
                    Te = p("HIDE_VISIBLE_COMPONENTS_CONTROLS_CHAPTERS"),
                    Se = p("HIDE_VISIBLE_COMPONENTS_CONTROLS_PROGRESSBAR"),
                    _e = p("HIDE_SHARE_PLAYTIME"),
                    Ne = p("BACKEND_ERROR"),
                    Ae = (p("NETWORK_EMPTY"), p("NETWORK_NO_SOURCE"), p("ERROR_MISSING_AUDIO_FILES"), p("ERROR_POSTER_LOAD"), p("SIMULATE_PLAYTIME")),
                    Ie = (p("ENABLE_GHOST_MODE"), p("DISABLE_GHOST_MODE"), p("REQUEST_PLAY")),
                    xe = p("BACKEND_PLAY"),
                    Re = p("REQUEST_PAUSE"),
                    je = p("BACKEND_PAUSE"),
                    Me = p("REQUEST_RESTART"),
                    Pe = p("BACKEND_BUFFER"),
                    Le = (p("REQUEST_STOP"), p("IDLE"), p("BACKEND_LOADING_START")),
                    Ce = p("BACKEND_LOADING_END"),
                    ke = (p("REQUEST_LOAD"), p("LOADED"), p("BACKEND_END")),
                    De = (p("MUTE"), p("UNMUTE"), p("SET_VOLUME"), p("SET_RATE"), p("BACKEND_DURATION")),
                    He = p("BACKEND_PLAYTIME"),
                    Fe = p("REQUEST_PLAYTIME"),
                    ze = (p("UPDATE_PLAYTIME"), p("BACKEND_LIVESYNC")),
                    Be = p("LOAD_QUANTILES"),
                    Ue = p("SET_QUANTILE"),
                    We = (p("SET_RUNTIME"), p("SET_LANGUAGE"), p("SET_VERSION"), p("SET_MODE"), p("SELECT_CONTENT"), p("SELECT_CHANNEL"), p("SELECT_EMBED_SIZE"), p("TOGGLE_TAB")),
                    Ve = (p("SET_TABS"), p("SET_THEME"), p("SET_TRANSCRIPTS_TIMELINE"), p("UPDATE_TRANSCRIPTS"), p("TOGGLE_FOLLOW_TRANSCRIPTS"), p("SEARCH_TRANSCRIPTS"), p("SET_SEARCH_TRANSCRIPTS_RESULTS"), p("NEXT_SEARCH_RESULT"), p("PREVIOUS_SEARCH_RESULT"), p("RESET_SEARCH_TRANSCRIPTS"), p("SHOW_ERROR"), p("HIDE_ERROR"), p("RETRY_PLAY"), p("ERROR_CONFIG_MEDIA"), p("ERROR_CONFIG_MISSING"), p("KEY_UP"), p("KEY_DOWN"), p("NEXT_PLAYLIST_ENTRY"), p("SELECT_PLAYLIST_ENTRY"), p("MARK_PLAYLIST_ENTRY_ACTIVE"), p("FILE_HOVER"), p("FILE_SELECT"), d(h)),
                    qe = (d(g), d(y)),
                    Ge = (d(m), function(e) {
                        return "".concat("BUTTON", "_").concat(e)
                    }),
                    Ye = Ge("INIT"),
                    Ke = (Ge("SHOW_LIST"), Ge("HIDE_LIST"), Ge("SHOW_OVERLAY"), Ge("HIDE_OVERLAY"), Ge("SHOW_FINISH_CARD"), Ge("HIDE_FINISH_CARD"), Ge("SET_RUNTIME"), Ge("SET_LANGUAGE"), Ge("SET_VERSION"), d(Ye));

                function Xe(e, t) {
                    switch (e) {
                        case 0:
                            return function() {
                                return t.apply(this, arguments)
                            };
                        case 1:
                            return function(e) {
                                return t.apply(this, arguments)
                            };
                        case 2:
                            return function(e, n) {
                                return t.apply(this, arguments)
                            };
                        case 3:
                            return function(e, n, r) {
                                return t.apply(this, arguments)
                            };
                        case 4:
                            return function(e, n, r, o) {
                                return t.apply(this, arguments)
                            };
                        case 5:
                            return function(e, n, r, o, i) {
                                return t.apply(this, arguments)
                            };
                        case 6:
                            return function(e, n, r, o, i, a) {
                                return t.apply(this, arguments)
                            };
                        case 7:
                            return function(e, n, r, o, i, a, u) {
                                return t.apply(this, arguments)
                            };
                        case 8:
                            return function(e, n, r, o, i, a, u, c) {
                                return t.apply(this, arguments)
                            };
                        case 9:
                            return function(e, n, r, o, i, a, u, c, s) {
                                return t.apply(this, arguments)
                            };
                        case 10:
                            return function(e, n, r, o, i, a, u, c, s, l) {
                                return t.apply(this, arguments)
                            };
                        default:
                            throw new Error("First argument to _arity must be a non-negative integer no greater than ten")
                    }
                }

                function Qe(e, t) {
                    return function() {
                        return t.call(this, e.apply(this, arguments))
                    }
                }

                function $e(e) {
                    return null != e && "object" == typeof e && !0 === e["@@functional/placeholder"]
                }

                function Je(e) {
                    return function t(n) {
                        return 0 === arguments.length || $e(n) ? t : e.apply(this, arguments)
                    }
                }

                function Ze(e) {
                    return function t(n, r) {
                        switch (arguments.length) {
                            case 0:
                                return t;
                            case 1:
                                return $e(n) ? t : Je((function(t) {
                                    return e(n, t)
                                }));
                            default:
                                return $e(n) && $e(r) ? t : $e(n) ? Je((function(t) {
                                    return e(t, r)
                                })) : $e(r) ? Je((function(t) {
                                    return e(n, t)
                                })) : e(n, r)
                        }
                    }
                }

                function et(e) {
                    return function t(n, r, o) {
                        switch (arguments.length) {
                            case 0:
                                return t;
                            case 1:
                                return $e(n) ? t : Ze((function(t, r) {
                                    return e(n, t, r)
                                }));
                            case 2:
                                return $e(n) && $e(r) ? t : $e(n) ? Ze((function(t, n) {
                                    return e(t, r, n)
                                })) : $e(r) ? Ze((function(t, r) {
                                    return e(n, t, r)
                                })) : Je((function(t) {
                                    return e(n, r, t)
                                }));
                            default:
                                return $e(n) && $e(r) && $e(o) ? t : $e(n) && $e(r) ? Ze((function(t, n) {
                                    return e(t, n, o)
                                })) : $e(n) && $e(o) ? Ze((function(t, n) {
                                    return e(t, r, n)
                                })) : $e(r) && $e(o) ? Ze((function(t, r) {
                                    return e(n, t, r)
                                })) : $e(n) ? Je((function(t) {
                                    return e(t, r, o)
                                })) : $e(r) ? Je((function(t) {
                                    return e(n, t, o)
                                })) : $e(o) ? Je((function(t) {
                                    return e(n, r, t)
                                })) : e(n, r, o)
                        }
                    }
                }
                const tt = Array.isArray || function(e) {
                    return null != e && e.length >= 0 && "[object Array]" === Object.prototype.toString.call(e)
                };

                function nt(e) {
                    return "[object String]" === Object.prototype.toString.call(e)
                }
                const rt = Je((function(e) {
                    return !!tt(e) || !!e && "object" == typeof e && !nt(e) && (1 === e.nodeType ? !!e.length : 0 === e.length || e.length > 0 && e.hasOwnProperty(0) && e.hasOwnProperty(e.length - 1))
                }));
                var ot = function() {
                    function e(e) {
                        this.f = e
                    }
                    return e.prototype["@@transducer/init"] = function() {
                        throw new Error("init not implemented on XWrap")
                    }, e.prototype["@@transducer/result"] = function(e) {
                        return e
                    }, e.prototype["@@transducer/step"] = function(e, t) {
                        return this.f(e, t)
                    }, e
                }();
                const it = Ze((function(e, t) {
                    return Xe(e.length, (function() {
                        return e.apply(t, arguments)
                    }))
                }));

                function at(e, t, n) {
                    for (var r = n.next(); !r.done;) {
                        if ((t = e["@@transducer/step"](t, r.value)) && t["@@transducer/reduced"]) {
                            t = t["@@transducer/value"];
                            break
                        }
                        r = n.next()
                    }
                    return e["@@transducer/result"](t)
                }

                function ut(e, t, n, r) {
                    return e["@@transducer/result"](n[r](it(e["@@transducer/step"], e), t))
                }
                var ct = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator";

                function st(e, t, n) {
                    if ("function" == typeof e && (e = function(e) {
                            return new ot(e)
                        }(e)), rt(n)) return function(e, t, n) {
                        for (var r = 0, o = n.length; r < o;) {
                            if ((t = e["@@transducer/step"](t, n[r])) && t["@@transducer/reduced"]) {
                                t = t["@@transducer/value"];
                                break
                            }
                            r += 1
                        }
                        return e["@@transducer/result"](t)
                    }(e, t, n);
                    if ("function" == typeof n["fantasy-land/reduce"]) return ut(e, t, n, "fantasy-land/reduce");
                    if (null != n[ct]) return at(e, t, n[ct]());
                    if ("function" == typeof n.next) return at(e, t, n);
                    if ("function" == typeof n.reduce) return ut(e, t, n, "reduce");
                    throw new TypeError("reduce: list must be array or iterable")
                }
                const lt = et(st);

                function ft(e, t) {
                    return function() {
                        var n = arguments.length;
                        if (0 === n) return t();
                        var r = arguments[n - 1];
                        return tt(r) || "function" != typeof r[e] ? t.apply(this, arguments) : r[e].apply(r, Array.prototype.slice.call(arguments, 0, n - 1))
                    }
                }
                const dt = Je(ft("tail", et(ft("slice", (function(e, t, n) {
                    return Array.prototype.slice.call(n, e, t)
                })))(1, 1 / 0)));

                function pt() {
                    if (0 === arguments.length) throw new Error("pipe requires at least one argument");
                    return Xe(arguments[0].length, lt(Qe, arguments[0], dt(arguments)))
                }
                const mt = Je((function(e) {
                    return nt(e) ? e.split("").reverse().join("") : Array.prototype.slice.call(e, 0).reverse()
                }));

                function ht() {
                    if (0 === arguments.length) throw new Error("compose requires at least one argument");
                    return pt.apply(this, mt(arguments))
                }
                const gt = Ze((function(e, t) {
                        return null == t || t != t ? e : t
                    })),
                    yt = Number.isInteger || function(e) {
                        return e << 0 === e
                    },
                    vt = Ze((function(e, t) {
                        var n = e < 0 ? t.length + e : e;
                        return nt(t) ? t.charAt(n) : t[n]
                    })),
                    bt = Ze((function(e, t) {
                        return e.map((function(e) {
                            for (var n, r = t, o = 0; o < e.length;) {
                                if (null == r) return;
                                n = e[o], r = yt(n) ? vt(n, r) : r[n], o += 1
                            }
                            return r
                        }))
                    })),
                    wt = Ze((function(e, t) {
                        return bt([e], t)[0]
                    })),
                    Ot = et((function(e, t, n) {
                        return gt(e, wt(t, n))
                    })),
                    Et = et((function(e, t, n) {
                        return Ot(e, [t], n)
                    }));

                function Tt(e) {
                    return null != e && "function" == typeof e["@@transducer/step"]
                }

                function St(e, t, n) {
                    return function() {
                        if (0 === arguments.length) return n();
                        var r = Array.prototype.slice.call(arguments, 0),
                            o = r.pop();
                        if (!tt(o)) {
                            for (var i = 0; i < e.length;) {
                                if ("function" == typeof o[e[i]]) return o[e[i]].apply(o, r);
                                i += 1
                            }
                            if (Tt(o)) {
                                var a = t.apply(null, r);
                                return a(o)
                            }
                        }
                        return n.apply(this, arguments)
                    }
                }

                function _t(e, t) {
                    for (var n = 0, r = t.length, o = Array(r); n < r;) o[n] = e(t[n]), n += 1;
                    return o
                }
                const Nt = function() {
                        return this.xf["@@transducer/init"]()
                    },
                    At = function(e) {
                        return this.xf["@@transducer/result"](e)
                    };
                var It = function() {
                    function e(e, t) {
                        this.xf = t, this.f = e
                    }
                    return e.prototype["@@transducer/init"] = Nt, e.prototype["@@transducer/result"] = At, e.prototype["@@transducer/step"] = function(e, t) {
                        return this.xf["@@transducer/step"](e, this.f(t))
                    }, e
                }();
                const xt = Ze((function(e, t) {
                    return new It(e, t)
                }));

                function Rt(e, t, n) {
                    return function() {
                        for (var r = [], o = 0, i = e, a = 0; a < t.length || o < arguments.length;) {
                            var u;
                            a < t.length && (!$e(t[a]) || o >= arguments.length) ? u = t[a] : (u = arguments[o], o += 1), r[a] = u, $e(u) || (i -= 1), a += 1
                        }
                        return i <= 0 ? n.apply(this, r) : Xe(i, Rt(e, r, n))
                    }
                }
                const jt = Ze((function(e, t) {
                    return 1 === e ? Je(t) : Xe(e, Rt(e, [], t))
                }));

                function Mt(e, t) {
                    return Object.prototype.hasOwnProperty.call(t, e)
                }
                var Pt = Object.prototype.toString;
                const Lt = function() {
                    return "[object Arguments]" === Pt.call(arguments) ? function(e) {
                        return "[object Arguments]" === Pt.call(e)
                    } : function(e) {
                        return Mt("callee", e)
                    }
                }();
                var Ct = !{
                        toString: null
                    }.propertyIsEnumerable("toString"),
                    kt = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
                    Dt = function() {
                        return arguments.propertyIsEnumerable("length")
                    }(),
                    Ht = function(e, t) {
                        for (var n = 0; n < e.length;) {
                            if (e[n] === t) return !0;
                            n += 1
                        }
                        return !1
                    };
                const Ft = "function" != typeof Object.keys || Dt ? Je((function(e) {
                        if (Object(e) !== e) return [];
                        var t, n, r = [],
                            o = Dt && Lt(e);
                        for (t in e) !Mt(t, e) || o && "length" === t || (r[r.length] = t);
                        if (Ct)
                            for (n = kt.length - 1; n >= 0;) Mt(t = kt[n], e) && !Ht(r, t) && (r[r.length] = t), n -= 1;
                        return r
                    })) : Je((function(e) {
                        return Object(e) !== e ? [] : Object.keys(e)
                    })),
                    zt = Ze(St(["fantasy-land/map", "map"], xt, (function(e, t) {
                        switch (Object.prototype.toString.call(t)) {
                            case "[object Function]":
                                return jt(t.length, (function() {
                                    return e.call(this, t.apply(this, arguments))
                                }));
                            case "[object Object]":
                                return st((function(n, r) {
                                    return n[r] = e(t[r]), n
                                }), {}, Ft(t));
                            default:
                                return _t(e, t)
                        }
                    }))),
                    Bt = Ze((function(e, t) {
                        return wt([e], t)
                    })),
                    Ut = Ze((function(e, t) {
                        return null != t && t.constructor === e || t instanceof e
                    }));

                function Wt(e, t, n) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e
                }
                const Vt = Je((function(e) {
                    return jt(e.length, e)
                }));

                function qt(e) {
                    return e
                }
                const Gt = Je(qt);

                function Yt(e) {
                    var t = Object.prototype.toString.call(e);
                    return "[object Function]" === t || "[object AsyncFunction]" === t || "[object GeneratorFunction]" === t || "[object AsyncGeneratorFunction]" === t
                }

                function Kt(e) {
                    for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
                    return n
                }

                function Xt(e, t, n) {
                    for (var r = 0, o = n.length; r < o;) {
                        if (e(t, n[r])) return !0;
                        r += 1
                    }
                    return !1
                }
                const Qt = "function" == typeof Object.is ? Object.is : function(e, t) {
                        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t
                    },
                    $t = Je((function(e) {
                        return null === e ? "Null" : void 0 === e ? "Undefined" : Object.prototype.toString.call(e).slice(8, -1)
                    }));

                function Jt(e, t, n, r) {
                    var o = Kt(e);

                    function i(e, t) {
                        return Zt(e, t, n.slice(), r.slice())
                    }
                    return !Xt((function(e, t) {
                        return !Xt(i, t, e)
                    }), Kt(t), o)
                }

                function Zt(e, t, n, r) {
                    if (Qt(e, t)) return !0;
                    var o, i, a = $t(e);
                    if (a !== $t(t)) return !1;
                    if (null == e || null == t) return !1;
                    if ("function" == typeof e["fantasy-land/equals"] || "function" == typeof t["fantasy-land/equals"]) return "function" == typeof e["fantasy-land/equals"] && e["fantasy-land/equals"](t) && "function" == typeof t["fantasy-land/equals"] && t["fantasy-land/equals"](e);
                    if ("function" == typeof e.equals || "function" == typeof t.equals) return "function" == typeof e.equals && e.equals(t) && "function" == typeof t.equals && t.equals(e);
                    switch (a) {
                        case "Arguments":
                        case "Array":
                        case "Object":
                            if ("function" == typeof e.constructor && "Promise" === (o = e.constructor, null == (i = String(o).match(/^function (\w*)/)) ? "" : i[1])) return e === t;
                            break;
                        case "Boolean":
                        case "Number":
                        case "String":
                            if (typeof e != typeof t || !Qt(e.valueOf(), t.valueOf())) return !1;
                            break;
                        case "Date":
                            if (!Qt(e.valueOf(), t.valueOf())) return !1;
                            break;
                        case "Error":
                            return e.name === t.name && e.message === t.message;
                        case "RegExp":
                            if (e.source !== t.source || e.global !== t.global || e.ignoreCase !== t.ignoreCase || e.multiline !== t.multiline || e.sticky !== t.sticky || e.unicode !== t.unicode) return !1
                    }
                    for (var u = n.length - 1; u >= 0;) {
                        if (n[u] === e) return r[u] === t;
                        u -= 1
                    }
                    switch (a) {
                        case "Map":
                            return e.size === t.size && Jt(e.entries(), t.entries(), n.concat([e]), r.concat([t]));
                        case "Set":
                            return e.size === t.size && Jt(e.values(), t.values(), n.concat([e]), r.concat([t]));
                        case "Arguments":
                        case "Array":
                        case "Object":
                        case "Boolean":
                        case "Number":
                        case "String":
                        case "Date":
                        case "Error":
                        case "RegExp":
                        case "Int8Array":
                        case "Uint8Array":
                        case "Uint8ClampedArray":
                        case "Int16Array":
                        case "Uint16Array":
                        case "Int32Array":
                        case "Uint32Array":
                        case "Float32Array":
                        case "Float64Array":
                        case "ArrayBuffer":
                            break;
                        default:
                            return !1
                    }
                    var c = Ft(e);
                    if (c.length !== Ft(t).length) return !1;
                    var s = n.concat([e]),
                        l = r.concat([t]);
                    for (u = c.length - 1; u >= 0;) {
                        var f = c[u];
                        if (!Mt(f, t) || !Zt(t[f], e[f], s, l)) return !1;
                        u -= 1
                    }
                    return !0
                }
                const en = Ze((function(e, t) {
                    return Zt(e, t, [], [])
                }));

                function tn(e, t) {
                    return function(e, t, n) {
                        var r, o;
                        if ("function" == typeof e.indexOf) switch (typeof t) {
                            case "number":
                                if (0 === t) {
                                    for (r = 1 / t; n < e.length;) {
                                        if (0 === (o = e[n]) && 1 / o === r) return n;
                                        n += 1
                                    }
                                    return -1
                                }
                                if (t != t) {
                                    for (; n < e.length;) {
                                        if ("number" == typeof(o = e[n]) && o != o) return n;
                                        n += 1
                                    }
                                    return -1
                                }
                                return e.indexOf(t, n);
                            case "string":
                            case "boolean":
                            case "function":
                            case "undefined":
                                return e.indexOf(t, n);
                            case "object":
                                if (null === t) return e.indexOf(t, n)
                        }
                        for (; n < e.length;) {
                            if (en(e[n], t)) return n;
                            n += 1
                        }
                        return -1
                    }(t, e, 0) >= 0
                }

                function nn(e) {
                    return '"' + e.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0").replace(/"/g, '\\"') + '"'
                }
                var rn = function(e) {
                    return (e < 10 ? "0" : "") + e
                };
                const on = "function" == typeof Date.prototype.toISOString ? function(e) {
                    return e.toISOString()
                } : function(e) {
                    return e.getUTCFullYear() + "-" + rn(e.getUTCMonth() + 1) + "-" + rn(e.getUTCDate()) + "T" + rn(e.getUTCHours()) + ":" + rn(e.getUTCMinutes()) + ":" + rn(e.getUTCSeconds()) + "." + (e.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z"
                };

                function an(e) {
                    return "[object Object]" === Object.prototype.toString.call(e)
                }
                var un = function() {
                    function e(e, t) {
                        this.xf = t, this.f = e
                    }
                    return e.prototype["@@transducer/init"] = Nt, e.prototype["@@transducer/result"] = At, e.prototype["@@transducer/step"] = function(e, t) {
                        return this.f(t) ? this.xf["@@transducer/step"](e, t) : e
                    }, e
                }();
                const cn = Ze(St(["filter"], Ze((function(e, t) {
                        return new un(e, t)
                    })), (function(e, t) {
                        return an(t) ? st((function(n, r) {
                            return e(t[r]) && (n[r] = t[r]), n
                        }), {}, Ft(t)) : function(e, t) {
                            for (var n = 0, r = t.length, o = []; n < r;) e(t[n]) && (o[o.length] = t[n]), n += 1;
                            return o
                        }(e, t)
                    }))),
                    sn = Ze((function(e, t) {
                        return cn((n = e, function() {
                            return !n.apply(this, arguments)
                        }), t);
                        var n
                    }));

                function ln(e, t) {
                    var n = function(n) {
                            var r = t.concat([e]);
                            return tn(n, r) ? "<Circular>" : ln(n, r)
                        },
                        r = function(e, t) {
                            return _t((function(t) {
                                return nn(t) + ": " + n(e[t])
                            }), t.slice().sort())
                        };
                    switch (Object.prototype.toString.call(e)) {
                        case "[object Arguments]":
                            return "(function() { return arguments; }(" + _t(n, e).join(", ") + "))";
                        case "[object Array]":
                            return "[" + _t(n, e).concat(r(e, sn((function(e) {
                                return /^\d+$/.test(e)
                            }), Ft(e)))).join(", ") + "]";
                        case "[object Boolean]":
                            return "object" == typeof e ? "new Boolean(" + n(e.valueOf()) + ")" : e.toString();
                        case "[object Date]":
                            return "new Date(" + (isNaN(e.valueOf()) ? n(NaN) : nn(on(e))) + ")";
                        case "[object Null]":
                            return "null";
                        case "[object Number]":
                            return "object" == typeof e ? "new Number(" + n(e.valueOf()) + ")" : 1 / e == -1 / 0 ? "-0" : e.toString(10);
                        case "[object String]":
                            return "object" == typeof e ? "new String(" + n(e.valueOf()) + ")" : nn(e);
                        case "[object Undefined]":
                            return "undefined";
                        default:
                            if ("function" == typeof e.toString) {
                                var o = e.toString();
                                if ("[object Object]" !== o) return o
                            }
                            return "{" + r(e, Ft(e)).join(", ") + "}"
                    }
                }
                const fn = Je((function(e) {
                        return ln(e, [])
                    })),
                    dn = Ze((function(e, t) {
                        return jt(e + 1, (function() {
                            var n = arguments[e];
                            if (null != n && Yt(n[t])) return n[t].apply(n, Array.prototype.slice.call(arguments, 0, e));
                            throw new TypeError(fn(n) + ' does not have a method named "' + t + '"')
                        }))
                    })),
                    pn = dn(1, "join"),
                    mn = Ze((function(e, t) {
                        return t > e ? t : e
                    })),
                    hn = Ze((function(e, t) {
                        return zt(Bt(e), t)
                    })),
                    gn = Ze((function(e, t) {
                        return jt(lt(mn, 0, hn("length", t)), (function() {
                            var n = arguments,
                                r = this;
                            return e.apply(r, _t((function(e) {
                                return e.apply(r, n)
                            }), t))
                        }))
                    })),
                    yn = Je((function(e) {
                        return gn((function() {
                            return Array.prototype.slice.call(arguments, 0)
                        }), e)
                    })),
                    vn = dn(0, "toUpperCase"),
                    bn = vt(0);
                var wn, On, En = (wn = function(e) {
                    return void 0 === e
                }, On = Je((function(e) {
                    return null == e
                })), function(e) {
                    return wn(e) || On(e)
                });

                function Tn(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter((function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable
                        }))), n.push.apply(n, r)
                    }
                    return n
                }

                function Sn(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Tn(Object(n), !0).forEach((function(t) {
                            Wt(e, t, n[t])
                        })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Tn(Object(n)).forEach((function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                        }))
                    }
                    return e
                }
                var _n = function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                        return isNaN(parseInt(e, 10)) ? 0 : parseInt(e, 10)
                    },
                    Nn = function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                        return isNaN(parseFloat(e)) ? 0 : parseFloat(e)
                    },
                    An = Vt((function(e, t) {
                        return zt((function(e) {
                            return e(t)
                        }), e)
                    })),
                    In = (Vt((function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Gt;
                        return Object.keys(e).reduce((function(n, r) {
                            return Sn(Sn({}, n), {}, Wt({}, r, ht(e[r], t)))
                        }), {})
                    })), Vt((function(e, t) {
                        return t.startsWith(e)
                    }))),
                    xn = Vt((function(e, t) {
                        return t.endsWith(e)
                    })),
                    Rn = Vt((function(e, t) {
                        return In(e, t) ? t.slice(e.length) : t
                    })),
                    jn = Vt((function(e, t) {
                        return xn(e, t) ? t.slice(0, t.length - e.length) : t
                    })),
                    Mn = (Vt((function(e, t) {
                        return Rn(e, jn(e, t))
                    })), ht(pn(""), yn([ht(vn, bn), dt])), new RegExp(/^(?:(\d{1,2}):)?(?:(\d{1,2}):)?(\d{1,2})(?:\.(\d{1,3}))?$/)),
                    Pn = function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "0";
                        if (Ut(Number, e) || En(e)) return e;
                        var t = Mn.exec(e);
                        if (!t) return 0;
                        var n = parseInt(t[2] ? t[1] : 0),
                            r = parseInt(t[2] ? t[2] : t[1] || 0),
                            o = parseInt(t[3] || 0),
                            i = parseInt(t[4] || 0);
                        return 60 * n * 60 * 1e3 + 60 * r * 1e3 + 1e3 * o + i
                    },
                    Ln = (ht(_n, (function(e) {
                        return 1e3 * e
                    }), Nn), ht(Nn, (function(e) {
                        return e / 1e3
                    }), _n)),
                    Cn = (ht((function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                        return parseInt(e % 60)
                    }), Ln), ht((function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                        return parseInt(e / 60) % 60
                    }), Ln), ht((function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                        return parseInt(e / 3600) % 24
                    }), Ln), ht(Pn, Et(0, "duration"))),
                    kn = (Et(null, "version"), ht(Pn, Et(0, "playtime"))),
                    Dn = (ht(zt(An({
                        url: Et(null, "url"),
                        size: Et(0, "size"),
                        title: Et(null, "title"),
                        mimeType: Et(null, "mimeType")
                    })), Et([], "audio")), Et([], "chapters")),
                    Hn = Et({}, "reference"),
                    Fn = Et([], "transcripts"),
                    zn = (ht(Et(null, "share"), Hn), ht(Et(null, "origin"), Hn), Et({}, "runtime")),
                    Bn = (ht(Bt("language"), zn), ht(Bt("platform"), zn), Et([], "playlist")),
                    Un = Bt("activeTab"),
                    Wn = Bt("subscribe-button"),
                    Vn = Et({}, "share"),
                    qn = (ht(Et([], "channels"), Vn), ht(Et(!1, "sharePlaytime"), Vn));
                const Gn = "5.12.2";
                var Yn = function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    window.resourceBaseUrl = Et("/", "base", e.reference), n.p = window.resourceBaseUrl
                };

                function Kn(e, t, n) {
                    var r, o = typeof e;
                    switch (o) {
                        case "string":
                        case "number":
                            return 0 === e && 1 / e == -1 / 0 ? !!n._items["-0"] || (t && (n._items["-0"] = !0), !1) : null !== n._nativeSet ? t ? (r = n._nativeSet.size, n._nativeSet.add(e), n._nativeSet.size === r) : n._nativeSet.has(e) : o in n._items ? e in n._items[o] || (t && (n._items[o][e] = !0), !1) : (t && (n._items[o] = {}, n._items[o][e] = !0), !1);
                        case "boolean":
                            if (o in n._items) {
                                var i = e ? 1 : 0;
                                return !!n._items[o][i] || (t && (n._items[o][i] = !0), !1)
                            }
                            return t && (n._items[o] = e ? [!1, !0] : [!0, !1]), !1;
                        case "function":
                            return null !== n._nativeSet ? t ? (r = n._nativeSet.size, n._nativeSet.add(e), n._nativeSet.size === r) : n._nativeSet.has(e) : o in n._items ? !!tn(e, n._items[o]) || (t && n._items[o].push(e), !1) : (t && (n._items[o] = [e]), !1);
                        case "undefined":
                            return !!n._items[o] || (t && (n._items[o] = !0), !1);
                        case "object":
                            if (null === e) return !!n._items.null || (t && (n._items.null = !0), !1);
                        default:
                            return (o = Object.prototype.toString.call(e)) in n._items ? !!tn(e, n._items[o]) || (t && n._items[o].push(e), !1) : (t && (n._items[o] = [e]), !1)
                    }
                }
                const Xn = function() {
                        function e() {
                            this._nativeSet = "function" == typeof Set ? new Set : null, this._items = {}
                        }
                        return e.prototype.add = function(e) {
                            return !Kn(e, !0, this)
                        }, e.prototype.has = function(e) {
                            return Kn(e, !1, this)
                        }, e
                    }(),
                    Qn = Ze((function(e, t) {
                        for (var n, r, o = new Xn, i = [], a = 0; a < t.length;) n = e(r = t[a]), o.add(n) && i.push(r), a += 1;
                        return i
                    }))(Gt),
                    $n = Ze((function(e, t) {
                        if (tt(e)) {
                            if (tt(t)) return e.concat(t);
                            throw new TypeError(fn(t) + " is not an array")
                        }
                        if (nt(e)) {
                            if (nt(t)) return e + t;
                            throw new TypeError(fn(t) + " is not a string")
                        }
                        if (null != e && Yt(e["fantasy-land/concat"])) return e["fantasy-land/concat"](t);
                        if (null != e && Yt(e.concat)) return e.concat(t);
                        throw new TypeError(fn(e) + ' does not have a method named "concat" or "fantasy-land/concat"')
                    }));

                n("../../node_modules/dompurify/dist/purify.js");
                var Jn = function(e) {
                        return "string" == typeof e ? bn(document.querySelectorAll(e)) : e
                    },
                    Zn = Vt((function(e, t) {
                        return e.appendChild(t), t
                    })),
                    er = Vt((function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                            n = arguments.length > 2 ? arguments[2] : void 0,
                            r = Object.keys(n || {}).map((function(e) {
                                return " ".concat(e, '="').concat(n[e], '"')
                            })).join("");
                        return "<".concat(e).concat(r, ">").concat(t, "</").concat(e, ">")
                    })),
                    tr = Vt((function(e, t) {
                        return Object.keys(e).forEach((function(n) {
                            t.style[n] = e[n]
                        })), t
                    })),
                    nr = Vt((function(e, t) {
                        (e || []).forEach((function(e) {
                            t.style.removeProperty(e)
                        }))
                    })),
                    rr = ht(cn(Gt), (function(e) {
                        return e.className.split(" ")
                    })),
                    or = (Vt((function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                            t = arguments.length > 1 ? arguments[1] : void 0;
                        return t.className = ht(pn(" "), Qn, $n(e), rr)(t), t
                    })), Vt((function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                            t = arguments.length > 1 ? arguments[1] : void 0;
                        return t.className = ht(pn(" "), cn((function(t) {
                            return !~e.indexOf(t)
                        })), rr)(t), t
                    })), Vt((function(e, t) {
                        return Object.keys(e).forEach((function(n) {
                            t.setAttribute(n, e[n])
                        })), t
                    })));

                function ir(e, t) {
                    return t = t || {}, new Promise((function(n, r) {
                        var o = new XMLHttpRequest,
                            i = [],
                            a = [],
                            u = {},
                            c = function() {
                                return {
                                    ok: 2 == (o.status / 100 | 0),
                                    statusText: o.statusText,
                                    status: o.status,
                                    url: o.responseURL,
                                    text: function() {
                                        return Promise.resolve(o.responseText)
                                    },
                                    json: function() {
                                        return Promise.resolve(JSON.parse(o.responseText))
                                    },
                                    blob: function() {
                                        return Promise.resolve(new Blob([o.response]))
                                    },
                                    clone: c,
                                    headers: {
                                        keys: function() {
                                            return i
                                        },
                                        entries: function() {
                                            return a
                                        },
                                        get: function(e) {
                                            return u[e.toLowerCase()]
                                        },
                                        has: function(e) {
                                            return e.toLowerCase() in u
                                        }
                                    }
                                }
                            };
                        for (var s in o.open(t.method || "get", e, !0), o.onload = function() {
                                o.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, (function(e, t, n) {
                                    i.push(t = t.toLowerCase()), a.push([t, n]), u[t] = u[t] ? u[t] + "," + n : n
                                })), n(c())
                            }, o.onerror = r, o.withCredentials = "include" == t.credentials, t.headers) o.setRequestHeader(s, t.headers[s]);
                        o.send(t.body || null)
                    }))
                }
                Vt((function(e, t) {
                    new MutationObserver(t).observe(e, {
                        childList: !0
                    }), window.addEventListener("resize", t)
                }));
                var ar = function() {
                        var e = o(a().mark((function e(t) {
                            var n;
                            return a().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        if (t && "string" == typeof t) {
                                            e.next = 2;
                                            break
                                        }
                                        return e.abrupt("return", t);
                                    case 2:
                                        return e.prev = 2, e.next = 5, ir(t);
                                    case 5:
                                        if (200 === (n = e.sent).status) {
                                            e.next = 8;
                                            break
                                        }
                                        return e.abrupt("return", null);
                                    case 8:
                                        if (n.headers.get("content-type").includes("application/json")) {
                                            e.next = 10;
                                            break
                                        }
                                        return e.abrupt("return", null);
                                    case 10:
                                        return e.abrupt("return", n.json());
                                    case 13:
                                        return e.prev = 13, e.t0 = e.catch(2), console.warn(e.t0), e.abrupt("return", null);
                                    case 17:
                                    case "end":
                                        return e.stop()
                                }
                            }), e, null, [
                                [2, 13]
                            ])
                        })));
                        return function(t) {
                            return e.apply(this, arguments)
                        }
                    }(),
                    ur = function() {
                        var e = o(a().mark((function e(t) {
                            var n;
                            return a().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        if ("string" == typeof t) {
                                            e.next = 2;
                                            break
                                        }
                                        return e.abrupt("return", t);
                                    case 2:
                                        return e.prev = 2, e.next = 5, ir(t);
                                    case 5:
                                        if (200 === (n = e.sent).status) {
                                            e.next = 8;
                                            break
                                        }
                                        return e.abrupt("return", null);
                                    case 8:
                                        if (n.headers.get("content-type").includes("text/html")) {
                                            e.next = 10;
                                            break
                                        }
                                        return e.abrupt("return", null);
                                    case 10:
                                        return e.abrupt("return", n.text());
                                    case 13:
                                        return e.prev = 13, e.t0 = e.catch(2), console.warn(e.t0), e.abrupt("return", null);
                                    case 17:
                                    case "end":
                                        return e.stop()
                                }
                            }), e, null, [
                                [2, 13]
                            ])
                        })));
                        return function(t) {
                            return e.apply(this, arguments)
                        }
                    }();
                const cr = o(a().mark((function e() {
                    var t, r = arguments;
                    return a().wrap((function(e) {
                        for (;;) switch (e.prev = e.next) {
                            case 0:
                                t = r.length > 0 && void 0 !== r[0] ? r[0] : "", e.t0 = vn(t), e.next = "XL" === e.t0 ? 4 : "L" === e.t0 ? 7 : "M" === e.t0 ? 10 : 13;
                                break;
                            case 4:
                                return e.next = 6, n.e("variant-xl").then(n.bind(n, "./src/templates/variant-xl.html")).then(Bt("default"));
                            case 6:
                                return e.abrupt("return", e.sent);
                            case 7:
                                return e.next = 9, n.e("variant-l").then(n.bind(n, "./src/templates/variant-l.html")).then(Bt("default"));
                            case 9:
                                return e.abrupt("return", e.sent);
                            case 10:
                                return e.next = 12, n.e("variant-m").then(n.bind(n, "./src/templates/variant-m.html")).then(Bt("default"));
                            case 12:
                                return e.abrupt("return", e.sent);
                            case 13:
                                return e.abrupt("return", null);
                            case 14:
                            case "end":
                                return e.stop()
                        }
                    }), e)
                })));
                var sr = function() {
                    var e = o(a().mark((function e(t) {
                        var n, r;
                        return a().wrap((function(e) {
                            for (;;) switch (e.prev = e.next) {
                                case 0:
                                    if (n = t.getAttribute("data-template"), r = t.getAttribute("data-variant"), !n) {
                                        e.next = 6;
                                        break
                                    }
                                    return e.next = 5, ur(n);
                                case 5:
                                    return e.abrupt("return", e.sent);
                                case 6:
                                    if (!r) {
                                        e.next = 10;
                                        break
                                    }
                                    return e.next = 9, cr(r);
                                case 9:
                                    return e.abrupt("return", e.sent);
                                case 10:
                                    if (!t.innerHTML) {
                                        e.next = 12;
                                        break
                                    }
                                    return e.abrupt("return", t.innerHTML);
                                case 12:
                                    return e.next = 14, cr("xl");
                                case 14:
                                    return e.abrupt("return", e.sent);
                                case 15:
                                case "end":
                                    return e.stop()
                            }
                        }), e)
                    })));
                    return function(t) {
                        return e.apply(this, arguments)
                    }
                }();
                const lr = function() {
                        var e = o(a().mark((function e(t) {
                            var n;
                            return a().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return n = Jn(t), e.t0 = n, e.next = 4, sr(n);
                                    case 4:
                                        return e.t1 = e.sent, e.t2 = function() {
                                            n.innerHTML = ""
                                        }, e.abrupt("return", {
                                            node: e.t0,
                                            template: e.t1,
                                            init: e.t2
                                        });
                                    case 7:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })));
                        return function(t) {
                            return e.apply(this, arguments)
                        }
                    }(),
                    fr = function() {
                        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                        return t.forEach((function(e) {
                            e.store.subscribe((function() {
                                var n = Bt("lastAction", e.store.getState()),
                                    r = Bt("type", n);
                                try {
                                    t.forEach((function(t) {
                                        t.prefix !== e.prefix && (r.startsWith("@") || r.startsWith(t.prefix) && t.store.dispatch(n))
                                    }))
                                } catch (e) {}
                            }))
                        }))
                    };

                function dr(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
                    return r
                }

                function pr(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e
                    }(e) || function(e, t) {
                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != n) {
                            var r, o, i = [],
                                a = !0,
                                u = !1;
                            try {
                                for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0);
                            } catch (e) {
                                u = !0, o = e
                            } finally {
                                try {
                                    a || null == n.return || n.return()
                                } finally {
                                    if (u) throw o
                                }
                            }
                            return i
                        }
                    }(e, t) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return dr(e, t);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? dr(e, t) : void 0
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }
                const mr = et((function(e, t, n) {
                        var r, o = {};
                        for (r in t) Mt(r, t) && (o[r] = Mt(r, n) ? e(r, t[r], n[r]) : t[r]);
                        for (r in n) Mt(r, n) && !Mt(r, o) && (o[r] = n[r]);
                        return o
                    })),
                    hr = et((function e(t, n, r) {
                        return mr((function(n, r, o) {
                            return an(r) && an(o) ? e(t, r, o) : t(n, r, o)
                        }), n, r)
                    })),
                    gr = Ze((function(e, t) {
                        return hr((function(e, t, n) {
                            return n
                        }), e, t)
                    }));
                var yr = function() {
                        var e = o(a().mark((function e(t) {
                            return a().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.prev = 0, e.next = 3, ar(Dn(t));
                                    case 3:
                                        return e.abrupt("return", e.sent);
                                    case 6:
                                        return e.prev = 6, e.t0 = e.catch(0), console.warn("Couldn't parse chapters \"".concat(chapters, '", falling back to empty list')), e.abrupt("return", []);
                                    case 10:
                                    case "end":
                                        return e.stop()
                                }
                            }), e, null, [
                                [0, 6]
                            ])
                        })));
                        return function(t) {
                            return e.apply(this, arguments)
                        }
                    }(),
                    vr = function() {
                        var e = o(a().mark((function e(t) {
                            return a().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.prev = 0, e.next = 3, ar(Fn(t));
                                    case 3:
                                        return e.abrupt("return", e.sent);
                                    case 6:
                                        return e.prev = 6, e.t0 = e.catch(0), console.warn("Couldn't parse transcripts \"".concat(transcripts, '", falling back to empty list')), e.abrupt("return", []);
                                    case 10:
                                    case "end":
                                        return e.stop()
                                }
                            }), e, null, [
                                [0, 6]
                            ])
                        })));
                        return function(t) {
                            return e.apply(this, arguments)
                        }
                    }(),
                    br = function() {
                        var e = o(a().mark((function e(t) {
                            return a().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.prev = 0, e.abrupt("return", ar(Bn(t)));
                                    case 4:
                                        return e.prev = 4, e.t0 = e.catch(0), console.warn("Couldn't parse playlist \"".concat(playlist, '", falling back to empty list')), e.abrupt("return", []);
                                    case 8:
                                    case "end":
                                        return e.stop()
                                }
                            }), e, null, [
                                [0, 4]
                            ])
                        })));
                        return function(t) {
                            return e.apply(this, arguments)
                        }
                    }(),
                    wr = function(e, t) {
                        var n = e.episode,
                            r = e.config;
                        return {
                            episode: "string" == typeof n ? n : null,
                            config: "string" == typeof r ? r : null,
                            base: Et(null, "base", t.config),
                            share: Ot(null, ["share", "outlet"], t.config)
                        }
                    },
                    Or = function(e) {
                        var t = e.config;
                        return {
                            persistTab: Ot(!0, ["features", "persistTab"], t),
                            persistPlaystate: Ot(!0, ["features", "persistPlaystate"], t)
                        }
                    },
                    Er = function() {
                        var e = o(a().mark((function e(t) {
                            return a().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.prev = 0, e.next = 3, ar(t);
                                    case 3:
                                        return e.abrupt("return", e.sent);
                                    case 6:
                                        throw e.prev = 6, e.t0 = e.catch(0), new Error("Couldn't parse configuration \"".concat(t, '"'));
                                    case 9:
                                    case "end":
                                        return e.stop()
                                }
                            }), e, null, [
                                [0, 6]
                            ])
                        })));
                        return function(t) {
                            return e.apply(this, arguments)
                        }
                    }(),
                    Tr = function(e, t) {
                        return Promise.all([Er(e), Er(t)]).then(function() {
                            var n = o(a().mark((function n(r) {
                                var o, i, u, c, s, l, f, d;
                                return a().wrap((function(n) {
                                    for (;;) switch (n.prev = n.next) {
                                        case 0:
                                            return o = pr(r, 2), i = o[0], u = o[1], n.next = 3, Promise.all([vr(i), yr(i), br(u)]);
                                        case 3:
                                            return c = n.sent, s = pr(c, 3), l = s[0], f = s[1], d = s[2], n.abrupt("return", gr(Object.assign({}, i, {
                                                transcripts: l,
                                                chapters: f
                                            }), Object.assign({}, u, {
                                                playlist: d,
                                                reference: wr({
                                                    episode: e,
                                                    config: t
                                                }, {
                                                    episode: i,
                                                    config: u
                                                }),
                                                features: Or({
                                                    config: u
                                                })
                                            })));
                                        case 9:
                                        case "end":
                                            return n.stop()
                                    }
                                }), n)
                            })));
                            return function(e) {
                                return n.apply(this, arguments)
                            }
                        }())
                    },
                    Sr = ht(or({
                        "min-width": "100%",
                        seamless: "",
                        scrolling: "no",
                        frameborder: "0"
                    }), tr({
                        height: "auto"
                    }), (function(e) {
                        return document.createElement(e)
                    })),
                    _r = Bt("contentWindow"),
                    Nr = ht(Bt("document"), _r),
                    Ar = Vt((function(e, t) {
                        var n = function() {
                            return or({
                                width: e.offsetWidth
                            }, t)
                        };
                        return n(), window.addEventListener("load", n), window.addEventListener("resize", n), t
                    })),
                    Ir = Vt((function(e, t) {
                        return new Promise((function(n) {
                            var r = _r(t),
                                o = Nr(t);
                            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && (r.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__), o.open(), o.write(e), o.close(),
                                function e() {
                                    return "complete" === o.readyState ? n(t) : setTimeout(e, 150)
                                }()
                        }))
                    })),
                    xr = Vt((function(e, t) {
                        return new Promise((function(e) {
                            return e(Sr("iframe"))
                        })).then(Zn(e)).then(Ir(t))
                    })),
                    Rr = n("../../node_modules/iframe-resizer/index.js"),
                    jr = n("../../node_modules/raw-loader/index.js!../../node_modules/iframe-resizer/js/iframeResizer.contentWindow.min.js"),
                    Mr = n.n(jr),
                    Pr = n("./src/player/template.mustache"),
                    Lr = n.n(Pr),
                    Cr = er("style", n("../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/styles/loader.scss").Z.toString()),
                    kr = er("script", "\n  var app = document.getElementById('app')\n\n  window.addEventListener('load', function() {\n    setTimeout(function () {\n      app.className += ' loaded'\n    }, 600)\n  })\n"),
                    Dr = Bt("playtime");
                Bt("duration"), Bt("livesync");
                const Hr = function() {
                        for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                        var r = "function" != typeof t[t.length - 1] && t.pop(),
                            o = t;
                        if (void 0 === r) throw new TypeError("The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.");
                        return function(e, t) {
                            for (var n = arguments.length, i = Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++) i[a - 2] = arguments[a];
                            var u = void 0 === e,
                                c = void 0 === t;
                            return u && c && r ? r : o.reduce((function(e, n) {
                                return n.apply(void 0, [e, t].concat(i))
                            }), u && !c && r ? r : e)
                        }
                    },
                    Fr = function(e) {
                        if ("object" != typeof e || null === e) return !1;
                        for (var t = e; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
                        return Object.getPrototypeOf(e) === t
                    },
                    zr = function(e) {
                        return "undefined" != typeof Map && e instanceof Map
                    };

                function Br(e) {
                    if (zr(e)) return Array.from(e.keys());
                    if ("undefined" != typeof Reflect && "function" == typeof Reflect.ownKeys) return Reflect.ownKeys(e);
                    var t = Object.getOwnPropertyNames(e);
                    return "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(e))), t
                }
                var Ur = "||";

                function Wr(e, t) {
                    return zr(t) ? t.get(e) : t[e]
                }
                const Vr = (qr = function(e) {
                    return (Fr(e) || zr(e)) && (t = Br(e), n = t.every((function(e) {
                        return "next" === e || "throw" === e
                    })), !(t.length && t.length <= 2 && n));
                    var t, n
                }, function e(t, n, r, o) {
                    var i = void 0 === n ? {} : n,
                        a = i.namespace,
                        u = void 0 === a ? "/" : a,
                        c = i.prefix;
                    return void 0 === r && (r = {}), void 0 === o && (o = ""), Br(t).forEach((function(n) {
                        var i = function(e) {
                                return o || !c || c && new RegExp("^" + c + u).test(e) ? e : "" + c + u + e
                            }(function(e) {
                                var t;
                                if (!o) return e;
                                var n = e.toString().split(Ur),
                                    r = o.split(Ur);
                                return (t = []).concat.apply(t, r.map((function(e) {
                                    return n.map((function(t) {
                                        return "" + e + u + t
                                    }))
                                }))).join(Ur)
                            }(n)),
                            a = Wr(n, t);
                        qr(a) ? e(a, {
                            namespace: u,
                            prefix: c
                        }, r, i) : r[i] = a
                    })), r
                });
                var qr;
                const Gr = function(e) {
                    return e.toString()
                };
                var Yr;

                function Kr(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter((function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable
                        }))), n.push.apply(n, r)
                    }
                    return n
                }

                function Xr(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Kr(Object(n), !0).forEach((function(t) {
                            Wt(e, t, n[t])
                        })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Kr(Object(n)).forEach((function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                        }))
                    }
                    return e
                }! function(e, t, n) {
                    void 0 === n && (n = {}), c()(Fr(e) || zr(e), "Expected handlers to be a plain object.");
                    var r = Vr(e, n),
                        o = Br(r).map((function(e) {
                            return function(e, t, n) {
                                void 0 === t && (t = l);
                                var r = Gr(e).split(Ur);
                                c()(!(void 0 === n), "defaultState for reducer handling " + r.join(", ") + " should be defined"), c()(s(t) || Fr(t), "Expected reducer to be a function or object with next and throw reducers");
                                var o = s(t) ? [t, t] : [t.next, t.throw].map((function(e) {
                                        return null == e ? l : e
                                    })),
                                    i = o[0],
                                    a = o[1];
                                return function(e, t) {
                                    void 0 === e && (e = n);
                                    var o = t.type;
                                    return o && -1 !== r.indexOf(Gr(o)) ? (!0 === t.error ? a : i)(e, t) : e
                                }
                            }(e, Wr(e, r), t)
                        }));
                    Hr.apply(void 0, o.concat([t]))
                }((Wt(Yr = {}, g, (function(e, t) {
                    var n = t.payload;
                    return Xr(Xr({}, e), {}, {
                        duration: Cn(n),
                        playtime: kn(n)
                    })
                })), Wt(Yr, De, (function(e, t) {
                    var n = t.payload;
                    return Xr(Xr({}, e), {}, {
                        duration: _n(n || e.duration)
                    })
                })), Wt(Yr, He, (function(e, t) {
                    var n = t.payload;
                    return Xr(Xr({}, e), {}, {
                        playtime: _n(n)
                    })
                })), Wt(Yr, Fe, (function(e, t) {
                    var n = t.payload;
                    return Xr(Xr({}, e), {}, {
                        playtime: _n(n)
                    })
                })), Wt(Yr, ze, (function(e, t) {
                    var n = t.payload;
                    return Xr(Xr({}, e), {}, {
                        livesync: _n(n)
                    })
                })), Yr), {
                    duration: 0,
                    playtime: 0,
                    livesync: 0
                });
                var Qr = d(Ie),
                    $r = (d(xe), d(Re)),
                    Jr = (d(je), d(Me), d(Le), d(Ce), d(Pe), d(ke), d(Ne), d(He)),
                    Zr = d(Fe),
                    eo = (d(Ae), d(De), d(ze), n("../../node_modules/query-string-for-all/dist/index.js")),
                    to = n.n(eo),
                    no = ht((function(e) {
                        var t = {};
                        if (e.t) {
                            var n = pr(e.t.split(","), 2),
                                r = n[0],
                                o = n[1];
                            t.starttime = "string" == typeof r ? Pn(r) : void 0, t.stoptime = "string" == typeof o ? Pn(o) : void 0
                        }
                        return e.episode && (t.episode = e.episode), e.config && (t.config = e.config), e.autoplay && (t.autoplay = !0), t
                    }), (function() {
                        return to().parse(window.location.search)
                    })),
                    ro = (d(v), d(b), d(w), d(O), d(M), d(E), d(T), d(S), d(D), d(_), d(N), d(A), d(I), d(x), d(R), d(j)),
                    oo = (d(P), d(L), d(C), d(k), d(H), d(W), d(Y), d(U), d(F), d(z), d(B), d(V), d(q), d(G), d(K), d(X), d(Q), d($), Vt((function(e, t) {
                        return new Promise((function(n) {
                            var r = t.subscribe((function() {
                                t.getState().lifecycle === e && (r(), n(t))
                            }));
                            t.dispatch({
                                type: "PLUGIN_CONNECT"
                            })
                        }))
                    }))),
                    io = oo("ready"),
                    ao = (oo("constructed"), ht(Dr, Et({}, "timepiece")));
                d(Ue);
                var uo = d(Be),
                    co = d(We);

                function so(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter((function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable
                        }))), n.push.apply(n, r)
                    }
                    return n
                }

                function lo(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? so(Object(n), !0).forEach((function(t) {
                            Wt(e, t, n[t])
                        })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : so(Object(n)).forEach((function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                        }))
                    }
                    return e
                }
                var fo = window.localStorage,
                    po = Vt((function(e, t) {
                        return [e, t].join("\0")
                    })),
                    mo = function(e) {
                        return lo(lo({}, new Error("Not Found [".concat(e, "]"))), {}, {
                            notFound: !0,
                            key: e
                        })
                    },
                    ho = n("../../node_modules/hashcode/hashcode.js"),
                    go = ht(Dr, Et({}, "timepiece")),
                    yo = Et([], "quantiles"),
                    vo = Et({}, "tabs"),
                    bo = Vt((function(e, t, n) {
                        n.subscribe(function(e, t) {
                            var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                                r = null,
                                o = !0;
                            return function() {
                                var i = arguments,
                                    a = this,
                                    u = function() {
                                        e.apply(a, i), r = null
                                    };
                                n && o && (o = !1, u()), r || (r = setTimeout(u, t))
                            }
                        }((function() {
                            var e = n.getState();
                            go(e), vo(e), yo(e)
                        }), 1e3))
                    }));
                const wo = Je((function(e) {
                        return null != e && "function" == typeof e["fantasy-land/empty"] ? e["fantasy-land/empty"]() : null != e && null != e.constructor && "function" == typeof e.constructor["fantasy-land/empty"] ? e.constructor["fantasy-land/empty"]() : null != e && "function" == typeof e.empty ? e.empty() : null != e && null != e.constructor && "function" == typeof e.constructor.empty ? e.constructor.empty() : tt(e) ? [] : nt(e) ? "" : an(e) ? {} : Lt(e) ? function() {
                            return arguments
                        }() : void 0
                    })),
                    Oo = Je((function(e) {
                        return null != e && en(e, wo(e))
                    }));
                d(J), d(de), d(Z), d(pe), d(ee), d(me), d(te), d(he), d(ne), d(ge), d(re), d(ye), d(oe), d(ve), d(ie), d(be), d(ae), d(we), d(ue), d(Oe), d(se), d(Te), d(ce), d(Ee), d(le), d(Se);
                var Eo = d(fe),
                    To = d(_e),
                    So = Vt((function(e, t) {
                        var n = "Podlove Web Player".concat(Bt("title", e) ? ": " + Bt("title", e) : "");
                        return or({
                            title: n,
                            "aria-label": n,
                            tabindex: 0
                        }, t)
                    })),
                    _o = function() {
                        var e = o(a().mark((function e(t, n) {
                            var r, o, i;
                            return a().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return r = Lr()({
                                            root: window.resourceBaseUrl,
                                            base: "".concat(Gn, "/player/"),
                                            styles: ["styles"],
                                            scripts: ["vendor", "styles", "bootstrap"],
                                            template: n.template,
                                            resizer: Mr(),
                                            loader: [Cr, kr].join("")
                                        }), e.next = 3, xr(n.node, r).then(Ar(n.node));
                                    case 3:
                                        return o = e.sent, So(t, o), (0, Rr.iframeResizer)({
                                            checkOrigin: !1,
                                            log: !1
                                        }, o), i = Bt("PODLOVE_STORE", _r(o)), e.abrupt("return", i);
                                    case 8:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })));
                        return function(t, n) {
                            return e.apply(this, arguments)
                        }
                    }(),
                    No = function(e, t) {
                        (function(e, t) {
                            var n = {
                                    selector: po("pwp"),
                                    get: function(e) {
                                        var t = this.selector(e);
                                        if (!fo[t]) return [mo(t)];
                                        try {
                                            return [null, JSON.parse(fo[t])]
                                        } catch (e) {
                                            return [e]
                                        }
                                    },
                                    put: function(e, t) {
                                        if (void 0 === t) return [new Error("Invalid parameters to put, ('".concat(e, "', undefined)"))];
                                        try {
                                            var n = this.selector(e);
                                            return [null, fo[n] = JSON.stringify(t)]
                                        } catch (e) {
                                            return [e]
                                        }
                                    }
                                },
                                r = (0, ho.u)().value(e),
                                o = pr(n.get(r), 2)[1],
                                i = void 0 === o ? {} : o,
                                a = bo(r, n);
                            io(t).then((function() {
                                var n = t.getState().tabs,
                                    r = Et([], "quantiles", i);
                                if (e.features.persistPlaystate && (r.length > 0 && (t.dispatch(qe()), t.dispatch(ro())), i.playtime && t.dispatch(Jr(i.playtime)), i.quantiles && t.dispatch(uo(i.quantiles))), e.features.persistTab && i.tabs) {
                                    var o = Object.keys(i.tabs).find((function(e) {
                                        return i.tabs[e]
                                    }));
                                    n[o] || t.dispatch(co(o))
                                }
                                a(t)
                            }))
                        })(e, t),
                        function(e, t) {
                            var n = Un(e);
                            n && io(t).then((function() {
                                var e = t.getState();
                                wt(["tabs", n], e) || "chapters" === n && Oo(wt(["chapters", "list"], e)) || t.dispatch(co(n))
                            }))
                        }(e, t),
                        function(e, t) {
                            var n = qn(e);
                            io(t).then((function(e) {
                                n ? e.dispatch(Eo()) : e.dispatch(To())
                            }))
                        }(e, t),
                        function(e) {
                            io(e).then((function() {
                                var t = no(),
                                    n = t.starttime,
                                    r = t.stoptime,
                                    o = t.autoplay;
                                (n || o || r) && (e.dispatch(qe()), e.dispatch(ro())), n && e.dispatch(Zr(n)), o && e.dispatch(Qr()), r && function(e, t) {
                                    var n = t.subscribe((function() {
                                        ao(t.getState()) < e || (n(), t.dispatch($r()))
                                    }))
                                }(r, e)
                            }))
                        }(t)
                    },
                    Ao = n("./src/subscribe-button/template.mustache"),
                    Io = n.n(Ao);

                function xo(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter((function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable
                        }))), n.push.apply(n, r)
                    }
                    return n
                }
                var Ro = function() {
                        var e = o(a().mark((function e(t) {
                            var n, r, o, i;
                            return a().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return n = Et("/", "base", t.reference), r = Io()({
                                            root: n,
                                            base: "".concat(Gn, "/button/"),
                                            styles: ["styles"],
                                            scripts: ["vendor", "styles", "list"]
                                        }), e.next = 4, xr(document.body, r).then(tr({
                                            position: "fixed",
                                            width: 0,
                                            height: 0,
                                            top: 0,
                                            left: 0,
                                            overflow: "hidden",
                                            "z-index": 2147483647
                                        }));
                                    case 4:
                                        return o = e.sent, (i = Bt("PODLOVE_STORE", _r(o))).subscribe((function() {
                                            wt(["view", "overlay"], i.getState()) ? (tr({
                                                width: "100%",
                                                height: "100%"
                                            }, o), tr({
                                                overflow: "hidden"
                                            }, document.body)) : setTimeout((function() {
                                                tr({
                                                    width: 0,
                                                    height: 0
                                                }, o), nr(["overflow"], document.body)
                                            }), 300)
                                        })), e.abrupt("return", i);
                                    case 8:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        })));
                        return function(t) {
                            return e.apply(this, arguments)
                        }
                    }(),
                    jo = function() {
                        var e = o(a().mark((function e(t, n, r) {
                            var o, i, u, c;
                            return a().wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        return e.prev = 0, e.next = 3, Tr(n, r);
                                    case 3:
                                        return i = e.sent, Yn(i), e.next = 7, lr(t);
                                    case 7:
                                        return (o = e.sent).init(), e.next = 11, _o(i, o);
                                    case 11:
                                        if ((u = e.sent).dispatch(Ve(i)), !Wn(i)) {
                                            e.next = 19;
                                            break
                                        }
                                        return e.next = 16, Ro(i, o);
                                    case 16:
                                        (c = e.sent).dispatch(Ke((s = void 0, l = void 0, s = Et({}, "theme", a = i), l = Et({}, "subscribe-button", a), function(e) {
                                            for (var t = 1; t < arguments.length; t++) {
                                                var n = null != arguments[t] ? arguments[t] : {};
                                                t % 2 ? xo(Object(n), !0).forEach((function(t) {
                                                    Wt(e, t, n[t])
                                                })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xo(Object(n)).forEach((function(t) {
                                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                                                }))
                                            }
                                            return e
                                        }({
                                            theme: s,
                                            runtime: Et({}, "runtime", a)
                                        }, l)))), fr({
                                            store: u,
                                            prefix: "PLAYER"
                                        }, {
                                            store: c,
                                            prefix: "BUTTON"
                                        });
                                    case 19:
                                        try {
                                            No(i, u)
                                        } catch (e) {}
                                        return e.abrupt("return", u);
                                    case 23:
                                        e.prev = 23, e.t0 = e.catch(0), console.group("Error in Podlove Webplayer ".concat(Gn)), console.warn("selector", t), console.warn("config", n), console.warn(e.t0), console.groupEnd();
                                    case 30:
                                    case "end":
                                        return e.stop()
                                }
                                var a, s, l
                            }), e, null, [
                                [0, 23]
                            ])
                        })));
                        return function(t, n, r) {
                            return e.apply(this, arguments)
                        }
                    }();
                void 0 === window.podlovePlayer && (window.podlovePlayer = jo)
            },
            "../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!./src/styles/loader.scss": (e, t, n) => {
                "use strict";
                n.d(t, {
                    Z: () => i
                });
                var r = n("../../node_modules/css-loader/dist/runtime/api.js"),
                    o = n.n(r)()((function(e) {
                        return e[1]
                    }));
                o.push([e.id, "#app{opacity:1}#app.loaded{opacity:1}", ""]);
                const i = o
            },
            "../../node_modules/css-loader/dist/runtime/api.js": e => {
                "use strict";
                e.exports = function(e) {
                    var t = [];
                    return t.toString = function() {
                        return this.map((function(t) {
                            var n = e(t);
                            return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n
                        })).join("")
                    }, t.i = function(e, n, r) {
                        "string" == typeof e && (e = [
                            [null, e, ""]
                        ]);
                        var o = {};
                        if (r)
                            for (var i = 0; i < this.length; i++) {
                                var a = this[i][0];
                                null != a && (o[a] = !0)
                            }
                        for (var u = 0; u < e.length; u++) {
                            var c = [].concat(e[u]);
                            r && o[c[0]] || (n && (c[2] ? c[2] = "".concat(n, " and ").concat(c[2]) : c[2] = n), t.push(c))
                        }
                    }, t
                }
            },
            "../../node_modules/dompurify/dist/purify.js": function(e) {},
            "../../node_modules/hashcode/hashcode.js": (e, t) => {
                t.u = function() {
                    var e = function(e) {
                            e = e.toString();
                            var t, n = 0;
                            for (t = 0; t < e.length; t++) n = (n << 5) - n + e.charCodeAt(t) & 4294967295;
                            return n
                        },
                        t = function(t) {
                            var r = 0;
                            for (var o in t) t.hasOwnProperty(o) && (r += e(o + n(t[o])));
                            return r
                        },
                        n = function(n) {
                            var r = {
                                    string: e,
                                    number: e,
                                    boolean: e,
                                    object: t
                                },
                                o = typeof n;
                            return null != n && r[o] ? r[o](n) + e(o) : 0
                        };
                    return {
                        value: n
                    }
                }
            },
            "../../node_modules/hogan.js/lib/compiler.js": (e, t) => {
                ! function(e) {
                    var t = /\S/,
                        n = /\"/g,
                        r = /\n/g,
                        o = /\r/g,
                        i = /\\/g,
                        a = /\u2028/,
                        u = /\u2029/;

                    function c(e) {
                        return e.trim ? e.trim() : e.replace(/^\s*|\s*$/g, "")
                    }

                    function s(e, t, n) {
                        if (t.charAt(n) != e.charAt(0)) return !1;
                        for (var r = 1, o = e.length; r < o; r++)
                            if (t.charAt(n + r) != e.charAt(r)) return !1;
                        return !0
                    }
                    e.tags = {
                        "#": 1,
                        "^": 2,
                        "<": 3,
                        $: 4,
                        "/": 5,
                        "!": 6,
                        ">": 7,
                        "=": 8,
                        _v: 9,
                        "{": 10,
                        "&": 11,
                        _t: 12
                    }, e.scan = function(n, r) {
                        var o, i = n.length,
                            a = 0,
                            u = null,
                            l = null,
                            f = "",
                            d = [],
                            p = !1,
                            m = 0,
                            h = 0,
                            g = "{{",
                            y = "}}";

                        function v() {
                            f.length > 0 && (d.push({
                                tag: "_t",
                                text: new String(f)
                            }), f = "")
                        }

                        function b(n, r) {
                            if (v(), n && function() {
                                    for (var n = !0, r = h; r < d.length; r++)
                                        if (!(n = e.tags[d[r].tag] < e.tags._v || "_t" == d[r].tag && null === d[r].text.match(t))) return !1;
                                    return n
                                }())
                                for (var o, i = h; i < d.length; i++) d[i].text && ((o = d[i + 1]) && ">" == o.tag && (o.indent = d[i].text.toString()), d.splice(i, 1));
                            else r || d.push({
                                tag: "\n"
                            });
                            p = !1, h = d.length
                        }

                        function w(e, t) {
                            var n = "=" + y,
                                r = e.indexOf(n, t),
                                o = c(e.substring(e.indexOf("=", t) + 1, r)).split(" ");
                            return g = o[0], y = o[o.length - 1], r + n.length - 1
                        }
                        for (r && (r = r.split(" "), g = r[0], y = r[1]), m = 0; m < i; m++) 0 == a ? s(g, n, m) ? (--m, v(), a = 1) : "\n" == n.charAt(m) ? b(p) : f += n.charAt(m) : 1 == a ? (m += g.length - 1, "=" == (u = (l = e.tags[n.charAt(m + 1)]) ? n.charAt(m + 1) : "_v") ? (m = w(n, m), a = 0) : (l && m++, a = 2), p = m) : s(y, n, m) ? (d.push({
                            tag: u,
                            n: c(f),
                            otag: g,
                            ctag: y,
                            i: "/" == u ? p - g.length : m + y.length
                        }), f = "", m += y.length - 1, a = 0, "{" == u && ("}}" == y ? m++ : "}" === (o = d[d.length - 1]).n.substr(o.n.length - 1) && (o.n = o.n.substring(0, o.n.length - 1)))) : f += n.charAt(m);
                        return b(p, !0), d
                    };
                    var l = {
                        _t: !0,
                        "\n": !0,
                        $: !0,
                        "/": !0
                    };

                    function f(t, n, r, o) {
                        var i, a = [],
                            u = null,
                            c = null;
                        for (i = r[r.length - 1]; t.length > 0;) {
                            if (c = t.shift(), i && "<" == i.tag && !(c.tag in l)) throw new Error("Illegal content in < super tag.");
                            if (e.tags[c.tag] <= e.tags.$ || d(c, o)) r.push(c), c.nodes = f(t, c.tag, r, o);
                            else {
                                if ("/" == c.tag) {
                                    if (0 === r.length) throw new Error("Closing tag without opener: /" + c.n);
                                    if (u = r.pop(), c.n != u.n && !p(c.n, u.n, o)) throw new Error("Nesting error: " + u.n + " vs. " + c.n);
                                    return u.end = c.i, a
                                }
                                "\n" == c.tag && (c.last = 0 == t.length || "\n" == t[0].tag)
                            }
                            a.push(c)
                        }
                        if (r.length > 0) throw new Error("missing closing tag: " + r.pop().n);
                        return a
                    }

                    function d(e, t) {
                        for (var n = 0, r = t.length; n < r; n++)
                            if (t[n].o == e.n) return e.tag = "#", !0
                    }

                    function p(e, t, n) {
                        for (var r = 0, o = n.length; r < o; r++)
                            if (n[r].c == e && n[r].o == t) return !0
                    }

                    function m(e) {
                        var t = [];
                        for (var n in e.partials) t.push('"' + g(n) + '":{name:"' + g(e.partials[n].name) + '", ' + m(e.partials[n]) + "}");
                        return "partials: {" + t.join(",") + "}, subs: " + function(e) {
                            var t = [];
                            for (var n in e) t.push('"' + g(n) + '": function(c,p,t,i) {' + e[n] + "}");
                            return "{ " + t.join(",") + " }"
                        }(e.subs)
                    }
                    e.stringify = function(t, n, r) {
                        return "{code: function (c,p,i) { " + e.wrapMain(t.code) + " }," + m(t) + "}"
                    };
                    var h = 0;

                    function g(e) {
                        return e.replace(i, "\\\\").replace(n, '\\"').replace(r, "\\n").replace(o, "\\r").replace(a, "\\u2028").replace(u, "\\u2029")
                    }

                    function y(e) {
                        return ~e.indexOf(".") ? "d" : "f"
                    }

                    function v(e, t) {
                        var n = "<" + (t.prefix || "") + e.n + h++;
                        return t.partials[n] = {
                            name: e.n,
                            partials: {}
                        }, t.code += 't.b(t.rp("' + g(n) + '",c,p,"' + (e.indent || "") + '"));', n
                    }

                    function b(e, t) {
                        t.code += "t.b(t.t(t." + y(e.n) + '("' + g(e.n) + '",c,p,0)));'
                    }

                    function w(e) {
                        return "t.b(" + e + ");"
                    }
                    e.generate = function(t, n, r) {
                        h = 0;
                        var o = {
                            code: "",
                            subs: {},
                            partials: {}
                        };
                        return e.walk(t, o), r.asString ? this.stringify(o, n, r) : this.makeTemplate(o, n, r)
                    }, e.wrapMain = function(e) {
                        return 'var t=this;t.b(i=i||"");' + e + "return t.fl();"
                    }, e.template = e.Template, e.makeTemplate = function(e, t, n) {
                        var r = this.makePartials(e);
                        return r.code = new Function("c", "p", "i", this.wrapMain(e.code)), new this.template(r, t, this, n)
                    }, e.makePartials = function(e) {
                        var t, n = {
                            subs: {},
                            partials: e.partials,
                            name: e.name
                        };
                        for (t in n.partials) n.partials[t] = this.makePartials(n.partials[t]);
                        for (t in e.subs) n.subs[t] = new Function("c", "p", "t", "i", e.subs[t]);
                        return n
                    }, e.codegen = {
                        "#": function(t, n) {
                            n.code += "if(t.s(t." + y(t.n) + '("' + g(t.n) + '",c,p,1),c,p,0,' + t.i + "," + t.end + ',"' + t.otag + " " + t.ctag + '")){t.rs(c,p,function(c,p,t){', e.walk(t.nodes, n), n.code += "});c.pop();}"
                        },
                        "^": function(t, n) {
                            n.code += "if(!t.s(t." + y(t.n) + '("' + g(t.n) + '",c,p,1),c,p,1,0,0,"")){', e.walk(t.nodes, n), n.code += "};"
                        },
                        ">": v,
                        "<": function(t, n) {
                            var r = {
                                partials: {},
                                code: "",
                                subs: {},
                                inPartial: !0
                            };
                            e.walk(t.nodes, r);
                            var o = n.partials[v(t, n)];
                            o.subs = r.subs, o.partials = r.partials
                        },
                        $: function(t, n) {
                            var r = {
                                subs: {},
                                code: "",
                                partials: n.partials,
                                prefix: t.n
                            };
                            e.walk(t.nodes, r), n.subs[t.n] = r.code, n.inPartial || (n.code += 't.sub("' + g(t.n) + '",c,p,i);')
                        },
                        "\n": function(e, t) {
                            t.code += w('"\\n"' + (e.last ? "" : " + i"))
                        },
                        _v: function(e, t) {
                            t.code += "t.b(t.v(t." + y(e.n) + '("' + g(e.n) + '",c,p,0)));'
                        },
                        _t: function(e, t) {
                            t.code += w('"' + g(e.text) + '"')
                        },
                        "{": b,
                        "&": b
                    }, e.walk = function(t, n) {
                        for (var r, o = 0, i = t.length; o < i; o++)(r = e.codegen[t[o].tag]) && r(t[o], n);
                        return n
                    }, e.parse = function(e, t, n) {
                        return f(e, 0, [], (n = n || {}).sectionTags || [])
                    }, e.cache = {}, e.cacheKey = function(e, t) {
                        return [e, !!t.asString, !!t.disableLambda, t.delimiters, !!t.modelGet].join("||")
                    }, e.compile = function(t, n) {
                        n = n || {};
                        var r = e.cacheKey(t, n),
                            o = this.cache[r];
                        if (o) {
                            var i = o.partials;
                            for (var a in i) delete i[a].instance;
                            return o
                        }
                        return o = this.generate(this.parse(this.scan(t, n.delimiters), t, n), t, n), this.cache[r] = o
                    }
                }(t)
            },
            "../../node_modules/hogan.js/lib/hogan.js": (e, t, n) => {
                var r = n("../../node_modules/hogan.js/lib/compiler.js");
                r.Template = n("../../node_modules/hogan.js/lib/template.js").Template, r.template = r.Template, e.exports = r
            },
            "../../node_modules/hogan.js/lib/template.js": (e, t) => {
                ! function(e) {
                    function t(e, t, n) {
                        var r;
                        return t && "object" == typeof t && (void 0 !== t[e] ? r = t[e] : n && t.get && "function" == typeof t.get && (r = t.get(e))), r
                    }
                    e.Template = function(e, t, n, r) {
                        e = e || {}, this.r = e.code || this.r, this.c = n, this.options = r || {}, this.text = t || "", this.partials = e.partials || {}, this.subs = e.subs || {}, this.buf = ""
                    }, e.Template.prototype = {
                        r: function(e, t, n) {
                            return ""
                        },
                        v: function(e) {
                            return e = c(e), u.test(e) ? e.replace(n, "&amp;").replace(r, "&lt;").replace(o, "&gt;").replace(i, "&#39;").replace(a, "&quot;") : e
                        },
                        t: c,
                        render: function(e, t, n) {
                            return this.ri([e], t || {}, n)
                        },
                        ri: function(e, t, n) {
                            return this.r(e, t, n)
                        },
                        ep: function(e, t) {
                            var n = this.partials[e],
                                r = t[n.name];
                            if (n.instance && n.base == r) return n.instance;
                            if ("string" == typeof r) {
                                if (!this.c) throw new Error("No compiler available.");
                                r = this.c.compile(r, this.options)
                            }
                            if (!r) return null;
                            if (this.partials[e].base = r, n.subs) {
                                for (key in t.stackText || (t.stackText = {}), n.subs) t.stackText[key] || (t.stackText[key] = void 0 !== this.activeSub && t.stackText[this.activeSub] ? t.stackText[this.activeSub] : this.text);
                                r = function(e, t, n, r, o, i) {
                                    function a() {}

                                    function u() {}
                                    var c;
                                    a.prototype = e, u.prototype = e.subs;
                                    var s = new a;
                                    for (c in s.subs = new u, s.subsText = {}, s.buf = "", r = r || {}, s.stackSubs = r, s.subsText = i, t) r[c] || (r[c] = t[c]);
                                    for (c in r) s.subs[c] = r[c];
                                    for (c in o = o || {}, s.stackPartials = o, n) o[c] || (o[c] = n[c]);
                                    for (c in o) s.partials[c] = o[c];
                                    return s
                                }(r, n.subs, n.partials, this.stackSubs, this.stackPartials, t.stackText)
                            }
                            return this.partials[e].instance = r, r
                        },
                        rp: function(e, t, n, r) {
                            var o = this.ep(e, n);
                            return o ? o.ri(t, n, r) : ""
                        },
                        rs: function(e, t, n) {
                            var r = e[e.length - 1];
                            if (s(r))
                                for (var o = 0; o < r.length; o++) e.push(r[o]), n(e, t, this), e.pop();
                            else n(e, t, this)
                        },
                        s: function(e, t, n, r, o, i, a) {
                            var u;
                            return (!s(e) || 0 !== e.length) && ("function" == typeof e && (e = this.ms(e, t, n, r, o, i, a)), u = !!e, !r && u && t && t.push("object" == typeof e ? e : t[t.length - 1]), u)
                        },
                        d: function(e, n, r, o) {
                            var i, a = e.split("."),
                                u = this.f(a[0], n, r, o),
                                c = this.options.modelGet,
                                l = null;
                            if ("." === e && s(n[n.length - 2])) u = n[n.length - 1];
                            else
                                for (var f = 1; f < a.length; f++) void 0 !== (i = t(a[f], u, c)) ? (l = u, u = i) : u = "";
                            return !(o && !u) && (o || "function" != typeof u || (n.push(l), u = this.mv(u, n, r), n.pop()), u)
                        },
                        f: function(e, n, r, o) {
                            for (var i = !1, a = !1, u = this.options.modelGet, c = n.length - 1; c >= 0; c--)
                                if (void 0 !== (i = t(e, n[c], u))) {
                                    a = !0;
                                    break
                                } return a ? (o || "function" != typeof i || (i = this.mv(i, n, r)), i) : !o && ""
                        },
                        ls: function(e, t, n, r, o) {
                            var i = this.options.delimiters;
                            return this.options.delimiters = o, this.b(this.ct(c(e.call(t, r)), t, n)), this.options.delimiters = i, !1
                        },
                        ct: function(e, t, n) {
                            if (this.options.disableLambda) throw new Error("Lambda features disabled.");
                            return this.c.compile(e, this.options).render(t, n)
                        },
                        b: function(e) {
                            this.buf += e
                        },
                        fl: function() {
                            var e = this.buf;
                            return this.buf = "", e
                        },
                        ms: function(e, t, n, r, o, i, a) {
                            var u, c = t[t.length - 1],
                                s = e.call(c);
                            return "function" == typeof s ? !!r || (u = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text, this.ls(s, c, n, u.substring(o, i), a)) : s
                        },
                        mv: function(e, t, n) {
                            var r = t[t.length - 1],
                                o = e.call(r);
                            return "function" == typeof o ? this.ct(c(o.call(r)), r, n) : o
                        },
                        sub: function(e, t, n, r) {
                            var o = this.subs[e];
                            o && (this.activeSub = e, o(t, n, this, r), this.activeSub = !1)
                        }
                    };
                    var n = /&/g,
                        r = /</g,
                        o = />/g,
                        i = /\'/g,
                        a = /\"/g,
                        u = /[&<>\"\']/;

                    function c(e) {
                        return String(null == e ? "" : e)
                    }
                    var s = Array.isArray || function(e) {
                        return "[object Array]" === Object.prototype.toString.call(e)
                    }
                }(t)
            },
            "../../node_modules/iframe-resizer/index.js": (e, t, n) => {
                e.exports = n("../../node_modules/iframe-resizer/js/index.js")
            },
            "../../node_modules/iframe-resizer/js/iframeResizer.contentWindow.js": e => {
                ! function(t) {
                    if ("undefined" != typeof window) {
                        var n = !0,
                            r = "",
                            o = 0,
                            i = "",
                            a = null,
                            u = "",
                            c = !1,
                            s = {
                                resize: 1,
                                click: 1
                            },
                            l = 128,
                            f = !0,
                            d = 1,
                            p = "bodyOffset",
                            m = p,
                            h = !0,
                            g = "",
                            y = {},
                            v = 32,
                            b = null,
                            w = !1,
                            O = !1,
                            E = "[iFrameSizer]",
                            T = E.length,
                            S = "",
                            _ = {
                                max: 1,
                                min: 1,
                                bodyScroll: 1,
                                documentElementScroll: 1
                            },
                            N = "child",
                            A = window.parent,
                            I = "*",
                            x = 0,
                            R = !1,
                            j = null,
                            M = 16,
                            P = 1,
                            L = "scroll",
                            C = L,
                            k = window,
                            D = function() {
                                ie("onMessage function not defined")
                            },
                            H = function() {},
                            F = function() {},
                            z = {
                                height: function() {
                                    return ie("Custom height calculation function not defined"), document.documentElement.offsetHeight
                                },
                                width: function() {
                                    return ie("Custom width calculation function not defined"), document.body.scrollWidth
                                }
                            },
                            B = {},
                            U = !1;
                        try {
                            var W = Object.create({}, {
                                passive: {
                                    get: function() {
                                        U = !0
                                    }
                                }
                            });
                            window.addEventListener("test", ee, W), window.removeEventListener("test", ee, W)
                        } catch (e) {}
                        var V, q, G, Y, K, X, Q, $ = {
                                bodyOffset: function() {
                                    return document.body.offsetHeight + he("marginTop") + he("marginBottom")
                                },
                                offset: function() {
                                    return $.bodyOffset()
                                },
                                bodyScroll: function() {
                                    return document.body.scrollHeight
                                },
                                custom: function() {
                                    return z.height()
                                },
                                documentElementOffset: function() {
                                    return document.documentElement.offsetHeight
                                },
                                documentElementScroll: function() {
                                    return document.documentElement.scrollHeight
                                },
                                max: function() {
                                    return Math.max.apply(null, ye($))
                                },
                                min: function() {
                                    return Math.min.apply(null, ye($))
                                },
                                grow: function() {
                                    return $.max()
                                },
                                lowestElement: function() {
                                    return Math.max($.bodyOffset() || $.documentElementOffset(), ge("bottom", be()))
                                },
                                taggedElement: function() {
                                    return ve("bottom", "data-iframe-height")
                                }
                            },
                            J = {
                                bodyScroll: function() {
                                    return document.body.scrollWidth
                                },
                                bodyOffset: function() {
                                    return document.body.offsetWidth
                                },
                                custom: function() {
                                    return z.width()
                                },
                                documentElementScroll: function() {
                                    return document.documentElement.scrollWidth
                                },
                                documentElementOffset: function() {
                                    return document.documentElement.offsetWidth
                                },
                                scroll: function() {
                                    return Math.max(J.bodyScroll(), J.documentElementScroll())
                                },
                                max: function() {
                                    return Math.max.apply(null, ye(J))
                                },
                                min: function() {
                                    return Math.min.apply(null, ye(J))
                                },
                                rightMostElement: function() {
                                    return ge("right", be())
                                },
                                taggedElement: function() {
                                    return ve("right", "data-iframe-width")
                                }
                            },
                            Z = (V = we, K = null, X = 0, Q = function() {
                                X = Date.now(), K = null, Y = V.apply(q, G), K || (q = G = null)
                            }, function() {
                                var e = Date.now();
                                X || (X = e);
                                var t = M - (e - X);
                                return q = this, G = arguments, t <= 0 || t > M ? (K && (clearTimeout(K), K = null), X = e, Y = V.apply(q, G), K || (q = G = null)) : K || (K = setTimeout(Q, t)), Y
                            });
                        te(window, "message", (function(s) {
                            var d, p = {
                                init: function() {
                                    var e, d, p;
                                    g = s.data, A = s.source,
                                        function() {
                                            function e(e) {
                                                return "true" === e
                                            }
                                            var a = g.substr(T).split(":");
                                            S = a[0], o = t !== a[1] ? Number(a[1]) : o, c = t !== a[2] ? e(a[2]) : c, w = t !== a[3] ? e(a[3]) : w, v = t !== a[4] ? Number(a[4]) : v, n = t !== a[6] ? e(a[6]) : n, i = a[7], m = t !== a[8] ? a[8] : m, r = a[9], u = a[10], x = t !== a[11] ? Number(a[11]) : x, y.enable = t !== a[12] && e(a[12]), N = t !== a[13] ? a[13] : N, C = t !== a[14] ? a[14] : C, O = t !== a[15] ? Boolean(a[15]) : O
                                        }(), oe("Initialising iFrame (" + window.location.href + ")"),
                                        function() {
                                            function e() {
                                                var e = window.iFrameResizer;
                                                oe("Reading data from page: " + JSON.stringify(e)), Object.keys(e).forEach(ae, e), D = "onMessage" in e ? e.onMessage : D, H = "onReady" in e ? e.onReady : H, I = "targetOrigin" in e ? e.targetOrigin : I, m = "heightCalculationMethod" in e ? e.heightCalculationMethod : m, C = "widthCalculationMethod" in e ? e.widthCalculationMethod : C
                                            }

                                            function t(e, t) {
                                                return "function" == typeof e && (oe("Setup custom " + t + "CalcMethod"), z[t] = e, e = "custom"), e
                                            }
                                            "iFrameResizer" in window && Object === window.iFrameResizer.constructor && (e(), m = t(m, "height"), C = t(C, "width")), oe("TargetOrigin for parent set to: " + I)
                                        }(), t === i && (i = o + "px"), ue("margin", (d = "margin", -1 !== (p = i).indexOf("-") && (ie("Negative CSS value ignored for " + d), p = ""), p)), ue("background", r), ue("padding", u), (e = document.createElement("div")).style.clear = "both", e.style.display = "block", e.style.height = "0", document.body.appendChild(e), fe(), de(), document.documentElement.style.height = "", document.body.style.height = "", oe('HTML & body height set to "auto"'), oe("Enable public methods"), k.parentIFrame = {
                                            autoResize: function(e) {
                                                return !0 === e && !1 === n ? (n = !0, pe()) : !1 === e && !0 === n && (n = !1, se("remove"), null !== a && a.disconnect(), clearInterval(b)), _e(0, 0, "autoResize", JSON.stringify(n)), n
                                            },
                                            close: function() {
                                                _e(0, 0, "close")
                                            },
                                            getId: function() {
                                                return S
                                            },
                                            getPageInfo: function(e) {
                                                "function" == typeof e ? (F = e, _e(0, 0, "pageInfo")) : (F = function() {}, _e(0, 0, "pageInfoStop"))
                                            },
                                            moveToAnchor: function(e) {
                                                y.findTarget(e)
                                            },
                                            reset: function() {
                                                Se("parentIFrame.reset")
                                            },
                                            scrollTo: function(e, t) {
                                                _e(t, e, "scrollTo")
                                            },
                                            scrollToOffset: function(e, t) {
                                                _e(t, e, "scrollToOffset")
                                            },
                                            sendMessage: function(e, t) {
                                                _e(0, 0, "message", JSON.stringify(e), t)
                                            },
                                            setHeightCalculationMethod: function(e) {
                                                m = e, fe()
                                            },
                                            setWidthCalculationMethod: function(e) {
                                                C = e, de()
                                            },
                                            setTargetOrigin: function(e) {
                                                oe("Set targetOrigin: " + e), I = e
                                            },
                                            size: function(e, t) {
                                                Oe("size", "parentIFrame.size(" + (e || "") + (t ? "," + t : "") + ")", e, t)
                                            }
                                        },
                                        function() {
                                            function e(e) {
                                                _e(0, 0, e.type, e.screenY + ":" + e.screenX)
                                            }

                                            function t(t, n) {
                                                oe("Add event listener: " + n), te(window.document, t, e)
                                            }!0 === O && (t("mouseenter", "Mouse Enter"), t("mouseleave", "Mouse Leave"))
                                        }(), pe(), y = function() {
                                            function e() {
                                                return {
                                                    x: window.pageXOffset !== t ? window.pageXOffset : document.documentElement.scrollLeft,
                                                    y: window.pageYOffset !== t ? window.pageYOffset : document.documentElement.scrollTop
                                                }
                                            }

                                            function n(t) {
                                                var n = t.getBoundingClientRect(),
                                                    r = e();
                                                return {
                                                    x: parseInt(n.left, 10) + parseInt(r.x, 10),
                                                    y: parseInt(n.top, 10) + parseInt(r.y, 10)
                                                }
                                            }

                                            function r(e) {
                                                function r(e) {
                                                    var t = n(e);
                                                    oe("Moving to in page link (#" + o + ") at x: " + t.x + " y: " + t.y), _e(t.y, t.x, "scrollToOffset")
                                                }
                                                var o = e.split("#")[1] || e,
                                                    i = decodeURIComponent(o),
                                                    a = document.getElementById(i) || document.getElementsByName(i)[0];
                                                t !== a ? r(a) : (oe("In page link (#" + o + ") not found in iFrame, so sending to parent"), _e(0, 0, "inPageLink", "#" + o))
                                            }

                                            function o() {
                                                var e = window.location.hash,
                                                    t = window.location.href;
                                                "" !== e && "#" !== e && r(t)
                                            }

                                            function i() {
                                                function e(e) {
                                                    function t(e) {
                                                        e.preventDefault(), r(this.getAttribute("href"))
                                                    }
                                                    "#" !== e.getAttribute("href") && te(e, "click", t)
                                                }
                                                Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), e)
                                            }

                                            function a() {
                                                te(window, "hashchange", o)
                                            }

                                            function u() {
                                                setTimeout(o, l)
                                            }

                                            function c() {
                                                Array.prototype.forEach && document.querySelectorAll ? (oe("Setting up location.hash handlers"), i(), a(), u()) : ie("In page linking not fully supported in this browser! (See README.md for IE8 workaround)")
                                            }
                                            return y.enable ? c() : oe("In page linking not enabled"), {
                                                findTarget: r
                                            }
                                        }(), Oe("init", "Init message from host page"), H(), f = !1, setTimeout((function() {
                                            h = !1
                                        }), l)
                                },
                                reset: function() {
                                    h ? oe("Page reset ignored by init") : (oe("Page size reset by host page"), Te("resetPage"))
                                },
                                resize: function() {
                                    Oe("resizeParent", "Parent window requested size check")
                                },
                                moveToAnchor: function() {
                                    y.findTarget(R())
                                },
                                inPageLink: function() {
                                    this.moveToAnchor()
                                },
                                pageInfo: function() {
                                    var e = R();
                                    oe("PageInfoFromParent called from parent: " + e), F(JSON.parse(e)), oe(" --")
                                },
                                message: function() {
                                    var e = R();
                                    oe("onMessage called from parent: " + e), D(JSON.parse(e)), oe(" --")
                                }
                            };

                            function _() {
                                return s.data.split("]")[1].split(":")[0]
                            }

                            function R() {
                                return s.data.substr(s.data.indexOf(":") + 1)
                            }

                            function j() {
                                return s.data.split(":")[2] in {
                                    true: 1,
                                    false: 1
                                }
                            }
                            E === ("" + s.data).substr(0, T) && (!1 === f ? (d = _()) in p ? p[d]() : !e.exports && "iFrameResize" in window || "jQuery" in window && "iFrameResize" in window.jQuery.prototype || j() || ie("Unexpected message (" + s.data + ")") : j() ? p.init() : oe('Ignored message of type "' + _() + '". Received before initialization.'))
                        })), te(window, "readystatechange", Ne), Ne()
                    }

                    function ee() {}

                    function te(e, t, n, r) {
                        e.addEventListener(t, n, !!U && (r || {}))
                    }

                    function ne(e) {
                        return e.charAt(0).toUpperCase() + e.slice(1)
                    }

                    function re(e) {
                        return E + "[" + S + "] " + e
                    }

                    function oe(e) {
                        w && "object" == typeof window.console && console.log(re(e))
                    }

                    function ie(e) {
                        "object" == typeof window.console && console.warn(re(e))
                    }

                    function ae(e) {
                        var t = e.split("Callback");
                        if (2 === t.length) {
                            var n = "on" + t[0].charAt(0).toUpperCase() + t[0].slice(1);
                            this[n] = this[e], delete this[e], ie("Deprecated: '" + e + "' has been renamed '" + n + "'. The old method will be removed in the next major version.")
                        }
                    }

                    function ue(e, n) {
                        t !== n && "" !== n && "null" !== n && (document.body.style[e] = n, oe("Body " + e + ' set to "' + n + '"'))
                    }

                    function ce(e) {
                        var t = {
                            add: function(t) {
                                function n() {
                                    Oe(e.eventName, e.eventType)
                                }
                                B[t] = n, te(window, t, n, {
                                    passive: !0
                                })
                            },
                            remove: function(e) {
                                var t, n, r = B[e];
                                delete B[e], t = e, n = r, window.removeEventListener(t, n, !1)
                            }
                        };
                        e.eventNames && Array.prototype.map ? (e.eventName = e.eventNames[0], e.eventNames.map(t[e.method])) : t[e.method](e.eventName), oe(ne(e.method) + " event listener: " + e.eventType)
                    }

                    function se(e) {
                        ce({
                            method: e,
                            eventType: "Animation Start",
                            eventNames: ["animationstart", "webkitAnimationStart"]
                        }), ce({
                            method: e,
                            eventType: "Animation Iteration",
                            eventNames: ["animationiteration", "webkitAnimationIteration"]
                        }), ce({
                            method: e,
                            eventType: "Animation End",
                            eventNames: ["animationend", "webkitAnimationEnd"]
                        }), ce({
                            method: e,
                            eventType: "Input",
                            eventName: "input"
                        }), ce({
                            method: e,
                            eventType: "Mouse Up",
                            eventName: "mouseup"
                        }), ce({
                            method: e,
                            eventType: "Mouse Down",
                            eventName: "mousedown"
                        }), ce({
                            method: e,
                            eventType: "Orientation Change",
                            eventName: "orientationchange"
                        }), ce({
                            method: e,
                            eventType: "Print",
                            eventName: ["afterprint", "beforeprint"]
                        }), ce({
                            method: e,
                            eventType: "Ready State Change",
                            eventName: "readystatechange"
                        }), ce({
                            method: e,
                            eventType: "Touch Start",
                            eventName: "touchstart"
                        }), ce({
                            method: e,
                            eventType: "Touch End",
                            eventName: "touchend"
                        }), ce({
                            method: e,
                            eventType: "Touch Cancel",
                            eventName: "touchcancel"
                        }), ce({
                            method: e,
                            eventType: "Transition Start",
                            eventNames: ["transitionstart", "webkitTransitionStart", "MSTransitionStart", "oTransitionStart", "otransitionstart"]
                        }), ce({
                            method: e,
                            eventType: "Transition Iteration",
                            eventNames: ["transitioniteration", "webkitTransitionIteration", "MSTransitionIteration", "oTransitionIteration", "otransitioniteration"]
                        }), ce({
                            method: e,
                            eventType: "Transition End",
                            eventNames: ["transitionend", "webkitTransitionEnd", "MSTransitionEnd", "oTransitionEnd", "otransitionend"]
                        }), "child" === N && ce({
                            method: e,
                            eventType: "IFrame Resized",
                            eventName: "resize"
                        })
                    }

                    function le(e, t, n, r) {
                        return t !== e && (e in n || (ie(e + " is not a valid option for " + r + "CalculationMethod."), e = t), oe(r + ' calculation method set to "' + e + '"')), e
                    }

                    function fe() {
                        m = le(m, p, $, "height")
                    }

                    function de() {
                        C = le(C, L, J, "width")
                    }

                    function pe() {
                        var e;
                        !0 === n ? (se("add"), e = 0 > v, window.MutationObserver || window.WebKitMutationObserver ? e ? me() : a = function() {
                            function e(e) {
                                function t(e) {
                                    !1 === e.complete && (oe("Attach listeners to " + e.src), e.addEventListener("load", r, !1), e.addEventListener("error", o, !1), a.push(e))
                                }
                                "attributes" === e.type && "src" === e.attributeName ? t(e.target) : "childList" === e.type && Array.prototype.forEach.call(e.target.querySelectorAll("img"), t)
                            }

                            function t(e) {
                                oe("Remove listeners from " + e.src), e.removeEventListener("load", r, !1), e.removeEventListener("error", o, !1),
                                    function(e) {
                                        a.splice(a.indexOf(e), 1)
                                    }(e)
                            }

                            function n(e, n, r) {
                                t(e.target), Oe(n, r + ": " + e.target.src)
                            }

                            function r(e) {
                                n(e, "imageLoad", "Image loaded")
                            }

                            function o(e) {
                                n(e, "imageLoadFailed", "Image load failed")
                            }

                            function i(t) {
                                Oe("mutationObserver", "mutationObserver: " + t[0].target + " " + t[0].type), t.forEach(e)
                            }
                            var a = [],
                                u = window.MutationObserver || window.WebKitMutationObserver,
                                c = function() {
                                    var e = document.querySelector("body");
                                    return c = new u(i), oe("Create body MutationObserver"), c.observe(e, {
                                        attributes: !0,
                                        attributeOldValue: !1,
                                        characterData: !0,
                                        characterDataOldValue: !1,
                                        childList: !0,
                                        subtree: !0
                                    }), c
                                }();
                            return {
                                disconnect: function() {
                                    "disconnect" in c && (oe("Disconnect body MutationObserver"), c.disconnect(), a.forEach(t))
                                }
                            }
                        }() : (oe("MutationObserver not supported in this browser!"), me())) : oe("Auto Resize disabled")
                    }

                    function me() {
                        0 !== v && (oe("setInterval: " + v + "ms"), b = setInterval((function() {
                            Oe("interval", "setInterval: " + v)
                        }), Math.abs(v)))
                    }

                    function he(e, t) {
                        var n = 0;
                        return t = t || document.body, n = null !== (n = document.defaultView.getComputedStyle(t, null)) ? n[e] : 0, parseInt(n, 10)
                    }

                    function ge(e, t) {
                        for (var n = t.length, r = 0, o = 0, i = ne(e), a = Date.now(), u = 0; u < n; u++)(r = t[u].getBoundingClientRect()[e] + he("margin" + i, t[u])) > o && (o = r);
                        return a = Date.now() - a, oe("Parsed " + n + " HTML elements"), oe("Element position calculated in " + a + "ms"),
                            function(e) {
                                e > M / 2 && oe("Event throttle increased to " + (M = 2 * e) + "ms")
                            }(a), o
                    }

                    function ye(e) {
                        return [e.bodyOffset(), e.bodyScroll(), e.documentElementOffset(), e.documentElementScroll()]
                    }

                    function ve(e, t) {
                        var n = document.querySelectorAll("[" + t + "]");
                        return 0 === n.length && (ie("No tagged elements (" + t + ") found on page"), document.querySelectorAll("body *")), ge(e, n)
                    }

                    function be() {
                        return document.querySelectorAll("body *")
                    }

                    function we(e, n, r, o) {
                        var i, a;
                        ! function() {
                            function e(e, t) {
                                return !(Math.abs(e - t) <= x)
                            }
                            return i = t !== r ? r : $[m](), a = t !== o ? o : J[C](), e(d, i) || c && e(P, a)
                        }() && "init" !== e ? !(e in {
                            init: 1,
                            interval: 1,
                            size: 1
                        }) && (m in _ || c && C in _) ? Se(n) : e in {
                            interval: 1
                        } || oe("No change in size detected") : (Ee(), _e(d = i, P = a, e))
                    }

                    function Oe(e, t, n, r) {
                        R && e in s ? oe("Trigger event cancelled: " + e) : (e in {
                            reset: 1,
                            resetPage: 1,
                            init: 1
                        } || oe("Trigger event: " + t), "init" === e ? we(e, t, n, r) : Z(e, t, n, r))
                    }

                    function Ee() {
                        R || (R = !0, oe("Trigger event lock on")), clearTimeout(j), j = setTimeout((function() {
                            R = !1, oe("Trigger event lock off"), oe("--")
                        }), l)
                    }

                    function Te(e) {
                        d = $[m](), P = J[C](), _e(d, P, e)
                    }

                    function Se(e) {
                        var t = m;
                        m = p, oe("Reset trigger event: " + e), Ee(), Te("reset"), m = t
                    }

                    function _e(e, n, r, o, i) {
                        var a;
                        t === i ? i = I : oe("Message targetOrigin: " + i), oe("Sending message to host page (" + (a = S + ":" + e + ":" + n + ":" + r + (t !== o ? ":" + o : "")) + ")"), A.postMessage(E + a, i)
                    }

                    function Ne() {
                        "loading" !== document.readyState && window.parent.postMessage("[iFrameResizerChild]Ready", "*")
                    }
                }()
            },
            "../../node_modules/iframe-resizer/js/iframeResizer.js": (e, t) => {
                var n, r, o;
                ! function(i) {
                    if ("undefined" != typeof window) {
                        var a, u = 0,
                            c = !1,
                            s = !1,
                            l = "message".length,
                            f = "[iFrameSizer]",
                            d = f.length,
                            p = null,
                            m = window.requestAnimationFrame,
                            h = {
                                max: 1,
                                scroll: 1,
                                bodyScroll: 1,
                                documentElementScroll: 1
                            },
                            g = {},
                            y = null,
                            v = {
                                autoResize: !0,
                                bodyBackground: null,
                                bodyMargin: null,
                                bodyMarginV1: 8,
                                bodyPadding: null,
                                checkOrigin: !0,
                                inPageLinks: !1,
                                enablePublicMethods: !0,
                                heightCalculationMethod: "bodyOffset",
                                id: "iFrameResizer",
                                interval: 32,
                                log: !1,
                                maxHeight: 1 / 0,
                                maxWidth: 1 / 0,
                                minHeight: 0,
                                minWidth: 0,
                                mouseEvents: !0,
                                resizeFrom: "parent",
                                scrolling: !1,
                                sizeHeight: !0,
                                sizeWidth: !1,
                                warningTimeout: 5e3,
                                tolerance: 0,
                                widthCalculationMethod: "scroll",
                                onClose: function() {
                                    return !0
                                },
                                onClosed: function() {},
                                onInit: function() {},
                                onMessage: function() {
                                    N("onMessage function not defined")
                                },
                                onMouseEnter: function() {},
                                onMouseLeave: function() {},
                                onResized: function() {},
                                onScroll: function() {
                                    return !0
                                }
                            },
                            b = {};
                        window.jQuery && ((a = window.jQuery).fn ? a.fn.iFrameResize || (a.fn.iFrameResize = function(e) {
                            return this.filter("iframe").each((function(t, n) {
                                z(n, e)
                            })).end()
                        }) : _("", "Unable to bind to jQuery, it is not fully loaded.")), r = [], (o = "function" == typeof(n = V) ? n.apply(t, r) : n) === i || (e.exports = o), window.iFrameResize = window.iFrameResize || V()
                    }

                    function w() {
                        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
                    }

                    function O(e, t, n) {
                        e.addEventListener(t, n, !1)
                    }

                    function E(e, t, n) {
                        e.removeEventListener(t, n, !1)
                    }

                    function T(e) {
                        return g[e] ? g[e].log : c
                    }

                    function S(e, t) {
                        A("log", e, t, T(e))
                    }

                    function _(e, t) {
                        A("info", e, t, T(e))
                    }

                    function N(e, t) {
                        A("warn", e, t, !0)
                    }

                    function A(e, t, n, r) {
                        !0 === r && "object" == typeof window.console && console[e](function(e) {
                            return f + "[" + function(e) {
                                var t = "Host page: " + e;
                                return window.top !== window.self && (t = window.parentIFrame && window.parentIFrame.getId ? window.parentIFrame.getId() + ": " + e : "Nested host page: " + e), t
                            }(e) + "]"
                        }(t), n)
                    }

                    function I(e) {
                        function t() {
                            n("Height"), n("Width"), D((function() {
                                k(I), P(R), s("onResized", I)
                            }), I, "init")
                        }

                        function n(e) {
                            var t = Number(g[R]["max" + e]),
                                n = Number(g[R]["min" + e]),
                                r = e.toLowerCase(),
                                o = Number(I[r]);
                            S(R, "Checking " + r + " is in range " + n + "-" + t), o < n && (o = n, S(R, "Set " + r + " to min value")), o > t && (o = t, S(R, "Set " + r + " to max value")), I[r] = "" + o
                        }

                        function r(e) {
                            return A.substr(A.indexOf(":") + l + e)
                        }

                        function o(e, t) {
                            var n, r;
                            n = function() {
                                var n, r;
                                H("Send Page Info", "pageInfo:" + (n = document.body.getBoundingClientRect(), r = I.iframe.getBoundingClientRect(), JSON.stringify({
                                    iframeHeight: r.height,
                                    iframeWidth: r.width,
                                    clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                                    clientWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                                    offsetTop: parseInt(r.top - n.top, 10),
                                    offsetLeft: parseInt(r.left - n.left, 10),
                                    scrollTop: window.pageYOffset,
                                    scrollLeft: window.pageXOffset,
                                    documentHeight: document.documentElement.clientHeight,
                                    documentWidth: document.documentElement.clientWidth,
                                    windowHeight: window.innerHeight,
                                    windowWidth: window.innerWidth
                                })), e, t)
                            }, b[r = t] || (b[r] = setTimeout((function() {
                                b[r] = null, n()
                            }), 32))
                        }

                        function i(e) {
                            var t = e.getBoundingClientRect();
                            return M(R), {
                                x: Math.floor(Number(t.left) + Number(p.x)),
                                y: Math.floor(Number(t.top) + Number(p.y))
                            }
                        }

                        function a(e) {
                            var t = e ? i(I.iframe) : {
                                    x: 0,
                                    y: 0
                                },
                                n = {
                                    x: Number(I.width) + t.x,
                                    y: Number(I.height) + t.y
                                };
                            S(R, "Reposition requested from iFrame (offset x:" + t.x + " y:" + t.y + ")"), window.top !== window.self ? window.parentIFrame ? window.parentIFrame["scrollTo" + (e ? "Offset" : "")](n.x, n.y) : N(R, "Unable to scroll to requested position, window.parentIFrame not found") : (p = n, u(), S(R, "--"))
                        }

                        function u() {
                            !1 !== s("onScroll", p) ? P(R) : L()
                        }

                        function c(e) {
                            var t = {};
                            if (0 === Number(I.width) && 0 === Number(I.height)) {
                                var n = r(9).split(":");
                                t = {
                                    x: n[1],
                                    y: n[0]
                                }
                            } else t = {
                                x: I.width,
                                y: I.height
                            };
                            s(e, {
                                iframe: I.iframe,
                                screenX: Number(t.x),
                                screenY: Number(t.y),
                                type: I.type
                            })
                        }

                        function s(e, t) {
                            return x(R, e, t)
                        }
                        var m, h, y, v, w, T, A = e.data,
                            I = {},
                            R = null;
                        "[iFrameResizerChild]Ready" === A ? function() {
                            for (var e in g) H("iFrame requested init", F(e), g[e].iframe, e)
                        }() : f === ("" + A).substr(0, d) && A.substr(d).split(":")[0] in g ? (v = (y = A.substr(d).split(":"))[1] ? parseInt(y[1], 10) : 0, w = g[y[0]] && g[y[0]].iframe, T = getComputedStyle(w), I = {
                            iframe: w,
                            id: y[0],
                            height: v + function(e) {
                                return "border-box" !== e.boxSizing ? 0 : (e.paddingTop ? parseInt(e.paddingTop, 10) : 0) + (e.paddingBottom ? parseInt(e.paddingBottom, 10) : 0)
                            }(T) + function(e) {
                                return "border-box" !== e.boxSizing ? 0 : (e.borderTopWidth ? parseInt(e.borderTopWidth, 10) : 0) + (e.borderBottomWidth ? parseInt(e.borderBottomWidth, 10) : 0)
                            }(T),
                            width: y[2],
                            type: y[3]
                        }, R = I.id, g[R] && (g[R].loaded = !0), (h = I.type in {
                            true: 1,
                            false: 1,
                            undefined: 1
                        }) && S(R, "Ignoring init message from meta parent page"), !h && function(e) {
                            var t = !0;
                            return g[e] || (t = !1, N(I.type + " No settings for " + e + ". Message was: " + A)), t
                        }(R) && (S(R, "Received: " + A), m = !0, null === I.iframe && (N(R, "IFrame (" + I.id + ") not found"), m = !1), m && function() {
                            var t, n = e.origin,
                                r = g[R] && g[R].checkOrigin;
                            if (r && "" + n != "null" && !(r.constructor === Array ? function() {
                                    var e = 0,
                                        t = !1;
                                    for (S(R, "Checking connection is from allowed list of origins: " + r); e < r.length; e++)
                                        if (r[e] === n) {
                                            t = !0;
                                            break
                                        } return t
                                }() : (t = g[R] && g[R].remoteHost, S(R, "Checking connection is from: " + t), n === t))) throw new Error("Unexpected message received from: " + n + " for " + I.iframe.id + ". Message was: " + e.data + ". This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.");
                            return !0
                        }() && function() {
                            switch (g[R] && g[R].firstRun && g[R] && (g[R].firstRun = !1), I.type) {
                                case "close":
                                    j(I.iframe);
                                    break;
                                case "message":
                                    d = r(6), S(R, "onMessage passed: {iframe: " + I.iframe.id + ", message: " + d + "}"), s("onMessage", {
                                        iframe: I.iframe,
                                        message: JSON.parse(d)
                                    }), S(R, "--");
                                    break;
                                case "mouseenter":
                                    c("onMouseEnter");
                                    break;
                                case "mouseleave":
                                    c("onMouseLeave");
                                    break;
                                case "autoResize":
                                    g[R].autoResize = JSON.parse(r(9));
                                    break;
                                case "scrollTo":
                                    a(!1);
                                    break;
                                case "scrollToOffset":
                                    a(!0);
                                    break;
                                case "pageInfo":
                                    o(g[R] && g[R].iframe, R),
                                        function() {
                                            function e(e, r) {
                                                function i() {
                                                    g[n] ? o(g[n].iframe, n) : t()
                                                } ["scroll", "resize"].forEach((function(t) {
                                                    S(n, e + t + " listener for sendPageInfo"), r(window, t, i)
                                                }))
                                            }

                                            function t() {
                                                e("Remove ", E)
                                            }
                                            var n = R;
                                            e("Add ", O), g[n] && (g[n].stopPageInfo = t)
                                        }();
                                    break;
                                case "pageInfoStop":
                                    g[R] && g[R].stopPageInfo && (g[R].stopPageInfo(), delete g[R].stopPageInfo);
                                    break;
                                case "inPageLink":
                                    n = r(9).split("#")[1] || "", l = decodeURIComponent(n), (f = document.getElementById(l) || document.getElementsByName(l)[0]) ? (e = i(f), S(R, "Moving to in page link (#" + n + ") at x: " + e.x + " y: " + e.y), p = {
                                        x: e.x,
                                        y: e.y
                                    }, u(), S(R, "--")) : window.top !== window.self ? window.parentIFrame ? window.parentIFrame.moveToAnchor(n) : S(R, "In page link #" + n + " not found and window.parentIFrame not found") : S(R, "In page link #" + n + " not found");
                                    break;
                                case "reset":
                                    C(I);
                                    break;
                                case "init":
                                    t(), s("onInit", I.iframe);
                                    break;
                                default:
                                    0 === Number(I.width) && 0 === Number(I.height) ? N("Unsupported message received (" + I.type + "), this is likely due to the iframe containing a later version of iframe-resizer than the parent page") : t()
                            }
                            var e, n, l, f, d
                        }())) : _(R, "Ignored: " + A)
                    }

                    function x(e, t, n) {
                        var r = null,
                            o = null;
                        if (g[e]) {
                            if ("function" != typeof(r = g[e][t])) throw new TypeError(t + " on iFrame[" + e + "] is not a function");
                            o = r(n)
                        }
                        return o
                    }

                    function R(e) {
                        var t = e.id;
                        delete g[t]
                    }

                    function j(e) {
                        var t = e.id;
                        if (!1 !== x(t, "onClose", t)) {
                            S(t, "Removing iFrame: " + t);
                            try {
                                e.parentNode && e.parentNode.removeChild(e)
                            } catch (e) {
                                N(e)
                            }
                            x(t, "onClosed", t), S(t, "--"), R(e)
                        } else S(t, "Close iframe cancelled by onClose event")
                    }

                    function M(e) {
                        null === p && S(e, "Get page position: " + (p = {
                            x: window.pageXOffset !== i ? window.pageXOffset : document.documentElement.scrollLeft,
                            y: window.pageYOffset !== i ? window.pageYOffset : document.documentElement.scrollTop
                        }).x + "," + p.y)
                    }

                    function P(e) {
                        null !== p && (window.scrollTo(p.x, p.y), S(e, "Set page position: " + p.x + "," + p.y), L())
                    }

                    function L() {
                        p = null
                    }

                    function C(e) {
                        S(e.id, "Size reset requested by " + ("init" === e.type ? "host page" : "iFrame")), M(e.id), D((function() {
                            k(e), H("reset", "reset", e.iframe, e.id)
                        }), e, "reset")
                    }

                    function k(e) {
                        function t(t) {
                            s || "0" !== e[t] || (s = !0, S(r, "Hidden iFrame detected, creating visibility listener"), function() {
                                function e() {
                                    Object.keys(g).forEach((function(e) {
                                        ! function(e) {
                                            function t(t) {
                                                return "0px" === (g[e] && g[e].iframe.style[t])
                                            }
                                            g[e] && null !== g[e].iframe.offsetParent && (t("height") || t("width")) && H("Visibility change", "resize", g[e].iframe, e)
                                        }(e)
                                    }))
                                }

                                function t(t) {
                                    S("window", "Mutation observed: " + t[0].target + " " + t[0].type), B(e, 16)
                                }
                                var n, r = w();
                                r && (n = document.querySelector("body"), new r(t).observe(n, {
                                    attributes: !0,
                                    attributeOldValue: !1,
                                    characterData: !0,
                                    characterDataOldValue: !1,
                                    childList: !0,
                                    subtree: !0
                                }))
                            }())
                        }

                        function n(n) {
                            ! function(t) {
                                e.id ? (e.iframe.style[t] = e[t] + "px", S(e.id, "IFrame (" + r + ") " + t + " set to " + e[t] + "px")) : S("undefined", "messageData id not set")
                            }(n), t(n)
                        }
                        var r = e.iframe.id;
                        g[r] && (g[r].sizeHeight && n("height"), g[r].sizeWidth && n("width"))
                    }

                    function D(e, t, n) {
                        n !== t.type && m && !window.jasmine ? (S(t.id, "Requesting animation frame"), m(e)) : e()
                    }

                    function H(e, t, n, r, o) {
                        var i, a = !1;
                        r = r || n.id, g[r] && (n && "contentWindow" in n && null !== n.contentWindow ? (i = g[r] && g[r].targetOrigin, S(r, "[" + e + "] Sending msg to iframe[" + r + "] (" + t + ") targetOrigin: " + i), n.contentWindow.postMessage(f + t, i)) : N(r, "[" + e + "] IFrame(" + r + ") not found"), o && g[r] && g[r].warningTimeout && (g[r].msgTimeout = setTimeout((function() {
                            !g[r] || g[r].loaded || a || (a = !0, N(r, "IFrame has not responded within " + g[r].warningTimeout / 1e3 + " seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning."))
                        }), g[r].warningTimeout)))
                    }

                    function F(e) {
                        return e + ":" + g[e].bodyMarginV1 + ":" + g[e].sizeWidth + ":" + g[e].log + ":" + g[e].interval + ":" + g[e].enablePublicMethods + ":" + g[e].autoResize + ":" + g[e].bodyMargin + ":" + g[e].heightCalculationMethod + ":" + g[e].bodyBackground + ":" + g[e].bodyPadding + ":" + g[e].tolerance + ":" + g[e].inPageLinks + ":" + g[e].resizeFrom + ":" + g[e].widthCalculationMethod + ":" + g[e].mouseEvents
                    }

                    function z(e, t) {
                        function n(e) {
                            var t = e.split("Callback");
                            if (2 === t.length) {
                                var n = "on" + t[0].charAt(0).toUpperCase() + t[0].slice(1);
                                this[n] = this[e], delete this[e], N(r, "Deprecated: '" + e + "' has been renamed '" + n + "'. The old method will be removed in the next major version.")
                            }
                        }
                        var r = function(n) {
                            var r;
                            return "" === n && (e.id = (r = t && t.id || v.id + u++, null !== document.getElementById(r) && (r += u++), n = r), c = (t || {}).log, S(n, "Added missing iframe ID: " + n + " (" + e.src + ")")), n
                        }(e.id);
                        r in g && "iFrameResizer" in e ? N(r, "Ignored iFrame, already setup.") : (function(t) {
                            var o;
                            t = t || {}, g[r] = {
                                    firstRun: !0,
                                    iframe: e,
                                    remoteHost: e.src && e.src.split("/").slice(0, 3).join("/")
                                },
                                function(e) {
                                    if ("object" != typeof e) throw new TypeError("Options is not an object")
                                }(t), Object.keys(t).forEach(n, t),
                                function(e) {
                                    for (var t in v) Object.prototype.hasOwnProperty.call(v, t) && (g[r][t] = Object.prototype.hasOwnProperty.call(e, t) ? e[t] : v[t])
                                }(t), g[r] && (g[r].targetOrigin = !0 === g[r].checkOrigin ? "" === (o = g[r].remoteHost) || null !== o.match(/^(about:blank|javascript:|file:\/\/)/) ? "*" : o : "*")
                        }(t), function() {
                            switch (S(r, "IFrame scrolling " + (g[r] && g[r].scrolling ? "enabled" : "disabled") + " for " + r), e.style.overflow = !1 === (g[r] && g[r].scrolling) ? "hidden" : "auto", g[r] && g[r].scrolling) {
                                case "omit":
                                    break;
                                case !0:
                                    e.scrolling = "yes";
                                    break;
                                case !1:
                                    e.scrolling = "no";
                                    break;
                                default:
                                    e.scrolling = g[r] ? g[r].scrolling : "no"
                            }
                        }(), function() {
                            function t(t) {
                                var n = g[r][t];
                                1 / 0 !== n && 0 !== n && (e.style[t] = "number" == typeof n ? n + "px" : n, S(r, "Set " + t + " = " + e.style[t]))
                            }

                            function n(e) {
                                if (g[r]["min" + e] > g[r]["max" + e]) throw new Error("Value for min" + e + " can not be greater than max" + e)
                            }
                            n("Height"), n("Width"), t("maxHeight"), t("minHeight"), t("maxWidth"), t("minWidth")
                        }(), "number" != typeof(g[r] && g[r].bodyMargin) && "0" !== (g[r] && g[r].bodyMargin) || (g[r].bodyMarginV1 = g[r].bodyMargin, g[r].bodyMargin = g[r].bodyMargin + "px"), function(t) {
                            var n = w();
                            n && function(t) {
                                e.parentNode && new t((function(t) {
                                    t.forEach((function(t) {
                                        Array.prototype.slice.call(t.removedNodes).forEach((function(t) {
                                            t === e && j(e)
                                        }))
                                    }))
                                })).observe(e.parentNode, {
                                    childList: !0
                                })
                            }(n), O(e, "load", (function() {
                                var n, o;
                                H("iFrame.onload", t, e, i, !0), n = g[r] && g[r].firstRun, o = g[r] && g[r].heightCalculationMethod in h, !n && o && C({
                                    iframe: e,
                                    height: 0,
                                    width: 0,
                                    type: "init"
                                })
                            })), H("init", t, e, i, !0)
                        }(F(r)), g[r] && (g[r].iframe.iFrameResizer = {
                            close: j.bind(null, g[r].iframe),
                            removeListeners: R.bind(null, g[r].iframe),
                            resize: H.bind(null, "Window resize", "resize", g[r].iframe),
                            moveToAnchor: function(e) {
                                H("Move to anchor", "moveToAnchor:" + e, g[r].iframe, r)
                            },
                            sendMessage: function(e) {
                                H("Send Message", "message:" + (e = JSON.stringify(e)), g[r].iframe, r)
                            }
                        }))
                    }

                    function B(e, t) {
                        null === y && (y = setTimeout((function() {
                            y = null, e()
                        }), t))
                    }

                    function U() {
                        "hidden" !== document.visibilityState && (S("document", "Trigger event: Visiblity change"), B((function() {
                            W("Tab Visable", "resize")
                        }), 16))
                    }

                    function W(e, t) {
                        Object.keys(g).forEach((function(n) {
                            (function(e) {
                                return g[e] && "parent" === g[e].resizeFrom && g[e].autoResize && !g[e].firstRun
                            })(n) && H(e, t, g[n].iframe, n)
                        }))
                    }

                    function V() {
                        function e(e, n) {
                            n && (function() {
                                if (!n.tagName) throw new TypeError("Object is not a valid DOM element");
                                if ("IFRAME" !== n.tagName.toUpperCase()) throw new TypeError("Expected <IFRAME> tag, found <" + n.tagName + ">")
                            }(), z(n, e), t.push(n))
                        }
                        var t;
                        return function() {
                                var e, t = ["moz", "webkit", "o", "ms"];
                                for (e = 0; e < t.length && !m; e += 1) m = window[t[e] + "RequestAnimationFrame"];
                                m ? m = m.bind(window) : S("setup", "RequestAnimationFrame not supported")
                            }(), O(window, "message", I), O(window, "resize", (function() {
                                S("window", "Trigger event: resize"), B((function() {
                                    W("Window resize", "resize")
                                }), 16)
                            })), O(document, "visibilitychange", U), O(document, "-webkit-visibilitychange", U),
                            function(n, r) {
                                switch (t = [], function(e) {
                                        e && e.enablePublicMethods && N("enablePublicMethods option has been removed, public methods are now always available in the iFrame")
                                    }(n), typeof r) {
                                    case "undefined":
                                    case "string":
                                        Array.prototype.forEach.call(document.querySelectorAll(r || "iframe"), e.bind(i, n));
                                        break;
                                    case "object":
                                        e(n, r);
                                        break;
                                    default:
                                        throw new TypeError("Unexpected data type (" + typeof r + ")")
                                }
                                return t
                            }
                    }
                }()
            },
            "../../node_modules/iframe-resizer/js/index.js": (e, t, n) => {
                var r = n("../../node_modules/iframe-resizer/js/iframeResizer.js");
                t.iframeResizer = r, n("../../node_modules/iframe-resizer/js/iframeResizer.contentWindow.js")
            },
            "../../node_modules/invariant/browser.js": e => {
                "use strict";
                e.exports = function(e, t, n, r, o, i, a, u) {
                    if (!e) {
                        var c;
                        if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
                        else {
                            var s = [n, r, o, i, a, u],
                                l = 0;
                            (c = new Error(t.replace(/%s/g, (function() {
                                return s[l++]
                            })))).name = "Invariant Violation"
                        }
                        throw c.framesToPop = 1, c
                    }
                }
            },
            "./src/player/template.mustache": (e, t, n) => {
                var r = n("../../node_modules/hogan.js/lib/hogan.js");
                e.exports = function() {
                    var e = new r.Template({
                        code: function(e, t, n) {
                            var r = this;
                            return r.b(n = n || ""), r.b('<!DOCTYPE html><html><head><meta charset="utf-8"><script type="text/javascript">window.resourceBaseUrl = \''), r.b(r.v(r.f("root", e, t, 0))), r.b(r.v(r.f("base", e, t, 0))), r.b('\';<\/script></head><body><div id="app" data-test="player"> '), r.b(r.t(r.f("template", e, t, 0))), r.b("</div> "), r.s(r.f("styles", e, t, 1), e, t, 0, 218, 282, "{{ }}") && (r.rs(e, t, (function(e, t, n) {
                                n.b(' <link rel="stylesheet" href="'), n.b(n.v(n.f("root", e, t, 0))), n.b(n.v(n.f("base", e, t, 0))), n.b(n.v(n.d(".", e, t, 0))), n.b('.css"> ')
                            })), e.pop()), r.b(" "), r.s(r.f("scripts", e, t, 1), e, t, 0, 306, 385, "{{ }}") && (r.rs(e, t, (function(e, t, n) {
                                n.b(' <script type="text/javascript" src="'), n.b(n.v(n.f("root", e, t, 0))), n.b(n.v(n.f("base", e, t, 0))), n.b(n.v(n.d(".", e, t, 0))), n.b('.js"><\/script> ')
                            })), e.pop()), r.b(" <script>window.iFrameResizer = {"), r.b("\n" + n), r.b("      heightCalculationMethod: 'documentElementOffset'"), r.b("\n" + n), r.b("    }; "), r.b(r.t(r.f("resizer", e, t, 0))), r.b("<\/script> "), r.b(r.t(r.f("loader", e, t, 0))), r.b("</body></html>"), r.fl()
                        },
                        partials: {},
                        subs: {}
                    }, '<!DOCTYPE html><html><head><meta charset="utf-8"><script type="text/javascript">window.resourceBaseUrl = \'{{ root }}{{ base }}\';<\/script></head><body><div id="app" data-test="player"> {{{ template }}}</div> {{#styles}} <link rel="stylesheet" href="{{ root }}{{ base }}{{ . }}.css"> {{/styles}} {{#scripts}} <script type="text/javascript" src="{{ root }}{{ base }}{{ . }}.js"><\/script> {{/scripts}} <script>window.iFrameResizer = {\n      heightCalculationMethod: \'documentElementOffset\'\n    }; {{{ resizer }}}<\/script> {{{ loader }}}</body></html>', r);
                    return e.render.apply(e, arguments)
                }
            },
            "./src/subscribe-button/template.mustache": (e, t, n) => {
                var r = n("../../node_modules/hogan.js/lib/hogan.js");
                e.exports = function() {
                    var e = new r.Template({
                        code: function(e, t, n) {
                            var r = this;
                            return r.b(n = n || ""), r.b('<!DOCTYPE html><html><head><meta charset="utf-8"><script type="text/javascript">window.resourceBaseUrl = \''), r.b(r.v(r.f("root", e, t, 0))), r.b(r.v(r.f("base", e, t, 0))), r.b('\';<\/script></head><body><div id="app"></div> '), r.s(r.f("styles", e, t, 1), e, t, 0, 182, 246, "{{ }}") && (r.rs(e, t, (function(e, t, n) {
                                n.b(' <link rel="stylesheet" href="'), n.b(n.v(n.f("root", e, t, 0))), n.b(n.v(n.f("base", e, t, 0))), n.b(n.v(n.d(".", e, t, 0))), n.b('.css"> ')
                            })), e.pop()), r.b(" "), r.s(r.f("scripts", e, t, 1), e, t, 0, 270, 349, "{{ }}") && (r.rs(e, t, (function(e, t, n) {
                                n.b(' <script type="text/javascript" src="'), n.b(n.v(n.f("root", e, t, 0))), n.b(n.v(n.f("base", e, t, 0))), n.b(n.v(n.d(".", e, t, 0))), n.b('.js"><\/script> ')
                            })), e.pop()), r.b(" </body></html>"), r.fl()
                        },
                        partials: {},
                        subs: {}
                    }, '<!DOCTYPE html><html><head><meta charset="utf-8"><script type="text/javascript">window.resourceBaseUrl = \'{{ root }}{{ base }}\';<\/script></head><body><div id="app"></div> {{#styles}} <link rel="stylesheet" href="{{ root }}{{ base }}{{ . }}.css"> {{/styles}} {{#scripts}} <script type="text/javascript" src="{{ root }}{{ base }}{{ . }}.js"><\/script> {{/scripts}} </body></html>', r);
                    return e.render.apply(e, arguments)
                }
            },
            "../../node_modules/query-string-for-all/dist/index.js": e => {
                e.exports = function(e) {
                    var t = {};

                    function n(r) {
                        if (t[r]) return t[r].exports;
                        var o = t[r] = {
                            i: r,
                            l: !1,
                            exports: {}
                        };
                        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports
                    }
                    return n.m = e, n.c = t, n.d = function(e, t, r) {
                        n.o(e, t) || Object.defineProperty(e, t, {
                            enumerable: !0,
                            get: r
                        })
                    }, n.r = function(e) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(e, "__esModule", {
                            value: !0
                        })
                    }, n.t = function(e, t) {
                        if (1 & t && (e = n(e)), 8 & t) return e;
                        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                        var r = Object.create(null);
                        if (n.r(r), Object.defineProperty(r, "default", {
                                enumerable: !0,
                                value: e
                            }), 2 & t && "string" != typeof e)
                            for (var o in e) n.d(r, o, function(t) {
                                return e[t]
                            }.bind(null, o));
                        return r
                    }, n.n = function(e) {
                        var t = e && e.__esModule ? function() {
                            return e.default
                        } : function() {
                            return e
                        };
                        return n.d(t, "a", t), t
                    }, n.o = function(e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t)
                    }, n.p = "", n(n.s = 0)
                }([function(e, t, n) {
                    "use strict";

                    function r(e, t) {
                        return function(e) {
                            if (Array.isArray(e)) return e
                        }(e) || function(e, t) {
                            var n = [],
                                r = !0,
                                o = !1,
                                i = void 0;
                            try {
                                for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
                            } catch (e) {
                                o = !0, i = e
                            } finally {
                                try {
                                    r || null == u.return || u.return()
                                } finally {
                                    if (o) throw i
                                }
                            }
                            return n
                        }(e, t) || function() {
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        }()
                    }

                    function o(e) {
                        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                            return typeof e
                        } : function(e) {
                            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                        })(e)
                    }

                    function i(e) {
                        return function(e) {
                            if (Array.isArray(e)) {
                                for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
                                return n
                            }
                        }(e) || function(e) {
                            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e)
                        }(e) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance")
                        }()
                    }
                    var a = n(1),
                        u = n(2),
                        c = n(3);

                    function s(e) {
                        if ("string" != typeof e || 1 !== e.length) throw new TypeError("arrayFormatSeparator must be single character string")
                    }

                    function l(e, t) {
                        return t.encode ? t.strict ? a(e) : encodeURIComponent(e) : e
                    }

                    function f(e, t) {
                        return t.decode ? u(e) : e
                    }

                    function d(e) {
                        return Array.isArray(e) ? e.sort() : "object" === o(e) ? d(Object.keys(e)).sort((function(e, t) {
                            return Number(e) - Number(t)
                        })).map((function(t) {
                            return e[t]
                        })) : e
                    }

                    function p(e) {
                        var t = e.indexOf("#");
                        return -1 !== t && (e = e.slice(0, t)), e
                    }

                    function m(e) {
                        var t = (e = p(e)).indexOf("?");
                        return -1 === t ? "" : e.slice(t + 1)
                    }

                    function h(e, t) {
                        return t.parseNumbers && !Number.isNaN(Number(e)) && "string" == typeof e && "" !== e.trim() ? e = Number(e) : !t.parseBooleans || null === e || "true" !== e.toLowerCase() && "false" !== e.toLowerCase() || (e = "true" === e.toLowerCase()), e
                    }

                    function g(e, t) {
                        s((t = Object.assign({
                            decode: !0,
                            sort: !0,
                            arrayFormat: "none",
                            arrayFormatSeparator: ",",
                            parseNumbers: !1,
                            parseBooleans: !1
                        }, t)).arrayFormatSeparator);
                        var n = function(e) {
                                var t;
                                switch (e.arrayFormat) {
                                    case "index":
                                        return function(e, n, r) {
                                            t = /\[(\d*)\]$/.exec(e), e = e.replace(/\[\d*\]$/, ""), t ? (void 0 === r[e] && (r[e] = {}), r[e][t[1]] = n) : r[e] = n
                                        };
                                    case "bracket":
                                        return function(e, n, r) {
                                            t = /(\[\])$/.exec(e), e = e.replace(/\[\]$/, ""), t ? void 0 !== r[e] ? r[e] = [].concat(r[e], n) : r[e] = [n] : r[e] = n
                                        };
                                    case "comma":
                                    case "separator":
                                        return function(t, n, r) {
                                            var o = "string" == typeof n && n.includes(e.arrayFormatSeparator),
                                                i = "string" == typeof n && !o && f(n, e).includes(e.arrayFormatSeparator);
                                            n = i ? f(n, e) : n;
                                            var a = o || i ? n.split(e.arrayFormatSeparator).map((function(t) {
                                                return f(t, e)
                                            })) : null === n ? n : f(n, e);
                                            r[t] = a
                                        };
                                    default:
                                        return function(e, t, n) {
                                            void 0 !== n[e] ? n[e] = [].concat(n[e], t) : n[e] = t
                                        }
                                }
                            }(t),
                            i = Object.create(null);
                        if ("string" != typeof e) return i;
                        if (!(e = e.trim().replace(/^[?#&]/, ""))) return i;
                        var a = !0,
                            u = !1,
                            l = void 0;
                        try {
                            for (var p, m = e.split("&")[Symbol.iterator](); !(a = (p = m.next()).done); a = !0) {
                                var g = p.value,
                                    y = r(c(t.decode ? g.replace(/\+/g, " ") : g, "="), 2),
                                    v = y[0];
                                O = void 0 === (O = y[1]) ? null : ["comma", "separator"].includes(t.arrayFormat) ? O : f(O, t), n(f(v, t), O, i)
                            }
                        } catch (e) {
                            u = !0, l = e
                        } finally {
                            try {
                                a || null == m.return || m.return()
                            } finally {
                                if (u) throw l
                            }
                        }
                        for (var b = 0, w = Object.keys(i); b < w.length; b++) {
                            var O;
                            if (v = w[b], "object" === o(O = i[v]) && null !== O)
                                for (var E = 0, T = Object.keys(O); E < T.length; E++) {
                                    var S = T[E];
                                    O[S] = h(O[S], t)
                                } else i[v] = h(O, t)
                        }
                        return !1 === t.sort ? i : (!0 === t.sort ? Object.keys(i).sort() : Object.keys(i).sort(t.sort)).reduce((function(e, t) {
                            var n = i[t];
                            return Boolean(n) && "object" === o(n) && !Array.isArray(n) ? e[t] = d(n) : e[t] = n, e
                        }), Object.create(null))
                    }
                    t.extract = m, t.parse = g, t.stringify = function(e, t) {
                        if (!e) return "";
                        s((t = Object.assign({
                            encode: !0,
                            strict: !0,
                            arrayFormat: "none",
                            arrayFormatSeparator: ","
                        }, t)).arrayFormatSeparator);
                        for (var n = function(n) {
                                return t.skipNull && null == e[n] || t.skipEmptyString && "" === e[n]
                            }, r = function(e) {
                                switch (e.arrayFormat) {
                                    case "index":
                                        return function(t) {
                                            return function(n, r) {
                                                var o = n.length;
                                                return void 0 === r || e.skipNull && null === r || e.skipEmptyString && "" === r ? n : [].concat(i(n), null === r ? [
                                                    [l(t, e), "[", o, "]"].join("")
                                                ] : [
                                                    [l(t, e), "[", l(o, e), "]=", l(r, e)].join("")
                                                ])
                                            }
                                        };
                                    case "bracket":
                                        return function(t) {
                                            return function(n, r) {
                                                return void 0 === r || e.skipNull && null === r || e.skipEmptyString && "" === r ? n : [].concat(i(n), null === r ? [
                                                    [l(t, e), "[]"].join("")
                                                ] : [
                                                    [l(t, e), "[]=", l(r, e)].join("")
                                                ])
                                            }
                                        };
                                    case "comma":
                                    case "separator":
                                        return function(t) {
                                            return function(n, r) {
                                                return null == r || 0 === r.length ? n : 0 === n.length ? [
                                                    [l(t, e), "=", l(r, e)].join("")
                                                ] : [
                                                    [n, l(r, e)].join(e.arrayFormatSeparator)
                                                ]
                                            }
                                        };
                                    default:
                                        return function(t) {
                                            return function(n, r) {
                                                return void 0 === r || e.skipNull && null === r || e.skipEmptyString && "" === r ? n : [].concat(i(n), null === r ? [l(t, e)] : [
                                                    [l(t, e), "=", l(r, e)].join("")
                                                ])
                                            }
                                        }
                                }
                            }(t), o = {}, a = 0, u = Object.keys(e); a < u.length; a++) {
                            var c = u[a];
                            n(c) || (o[c] = e[c])
                        }
                        var f = Object.keys(o);
                        return !1 !== t.sort && f.sort(t.sort), f.map((function(n) {
                            var o = e[n];
                            return void 0 === o ? "" : null === o ? l(n, t) : Array.isArray(o) ? o.reduce(r(n), []).join("&") : l(n, t) + "=" + l(o, t)
                        })).filter((function(e) {
                            return e.length > 0
                        })).join("&")
                    }, t.parseUrl = function(e, t) {
                        t = Object.assign({
                            decode: !0
                        }, t);
                        var n = r(c(e, "#"), 2),
                            o = n[0],
                            i = n[1];
                        return Object.assign({
                            url: o.split("?")[0] || "",
                            query: g(m(e), t)
                        }, t && t.parseFragmentIdentifier && i ? {
                            fragmentIdentifier: f(i, t)
                        } : {})
                    }, t.stringifyUrl = function(e, n) {
                        n = Object.assign({
                            encode: !0,
                            strict: !0
                        }, n);
                        var r = p(e.url).split("?")[0] || "",
                            o = t.extract(e.url),
                            i = t.parse(o, {
                                sort: !1
                            }),
                            a = Object.assign(i, e.query),
                            u = t.stringify(a, n);
                        u && (u = "?".concat(u));
                        var c = function(e) {
                            var t = "",
                                n = e.indexOf("#");
                            return -1 !== n && (t = e.slice(n)), t
                        }(e.url);
                        return e.fragmentIdentifier && (c = "#".concat(l(e.fragmentIdentifier, n))), "".concat(r).concat(u).concat(c)
                    }
                }, function(e, t, n) {
                    "use strict";
                    e.exports = function(e) {
                        return encodeURIComponent(e).replace(/[!'()*]/g, (function(e) {
                            return "%".concat(e.charCodeAt(0).toString(16).toUpperCase())
                        }))
                    }
                }, function(e, t, n) {
                    "use strict";

                    function r(e) {
                        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                            return typeof e
                        } : function(e) {
                            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                        })(e)
                    }
                    var o = "%[a-f0-9]{2}",
                        i = new RegExp(o, "gi"),
                        a = new RegExp("(" + o + ")+", "gi");

                    function u(e, t) {
                        try {
                            return decodeURIComponent(e.join(""))
                        } catch (e) {}
                        if (1 === e.length) return e;
                        t = t || 1;
                        var n = e.slice(0, t),
                            r = e.slice(t);
                        return Array.prototype.concat.call([], u(n), u(r))
                    }

                    function c(e) {
                        try {
                            return decodeURIComponent(e)
                        } catch (r) {
                            for (var t = e.match(i), n = 1; n < t.length; n++) t = (e = u(t, n).join("")).match(i);
                            return e
                        }
                    }
                    e.exports = function(e) {
                        if ("string" != typeof e) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + r(e) + "`");
                        try {
                            return e = e.replace(/\+/g, " "), decodeURIComponent(e)
                        } catch (t) {
                            return function(e) {
                                for (var t = {
                                        "%FE%FF": "��",
                                        "%FF%FE": "��"
                                    }, n = a.exec(e); n;) {
                                    try {
                                        t[n[0]] = decodeURIComponent(n[0])
                                    } catch (e) {
                                        var r = c(n[0]);
                                        r !== n[0] && (t[n[0]] = r)
                                    }
                                    n = a.exec(e)
                                }
                                t["%C2"] = "�";
                                for (var o = Object.keys(t), i = 0; i < o.length; i++) {
                                    var u = o[i];
                                    e = e.replace(new RegExp(u, "g"), t[u])
                                }
                                return e
                            }(e)
                        }
                    }
                }, function(e, t, n) {
                    "use strict";
                    e.exports = function(e, t) {
                        if ("string" != typeof e || "string" != typeof t) throw new TypeError("Expected the arguments to be of type `string`");
                        if ("" === t) return [e];
                        var n = e.indexOf(t);
                        return -1 === n ? [e] : [e.slice(0, n), e.slice(n + t.length)]
                    }
                }])
            },
            "../../node_modules/raw-loader/index.js!../../node_modules/iframe-resizer/js/iframeResizer.contentWindow.min.js": e => {
                e.exports = '/*! iFrame Resizer (iframeSizer.contentWindow.min.js) - v4.3.2 - 2021-04-26\n *  Desc: Include this file in any page being loaded into an iframe\n *        to force the iframe to resize to the content size.\n *  Requires: iframeResizer.min.js on host page.\n *  Copyright: (c) 2021 David J. Bradshaw - dave@bradshaw.net\n *  License: MIT\n */\n\n!function(c){if("undefined"!=typeof window){var i=!0,o=10,r="",a=0,u="",s=null,d="",l=!1,f={resize:1,click:1},m=128,h=!0,g=1,n="bodyOffset",p=n,v=!0,y="",w={},b=32,T=null,E=!1,O=!1,S="[iFrameSizer]",M=S.length,I="",N={max:1,min:1,bodyScroll:1,documentElementScroll:1},A="child",C=!0,z=window.parent,k="*",R=0,x=!1,e=null,L=16,F=1,t="scroll",P=t,D=window,j=function(){re("onMessage function not defined")},q=function(){},H=function(){},W={height:function(){return re("Custom height calculation function not defined"),document.documentElement.offsetHeight},width:function(){return re("Custom width calculation function not defined"),document.body.scrollWidth}},B={},J=!1;try{var U=Object.create({},{passive:{get:function(){J=!0}}});window.addEventListener("test",ee,U),window.removeEventListener("test",ee,U)}catch(e){}var V,X,Y,K,Q,G,Z={bodyOffset:function(){return document.body.offsetHeight+pe("marginTop")+pe("marginBottom")},offset:function(){return Z.bodyOffset()},bodyScroll:function(){return document.body.scrollHeight},custom:function(){return W.height()},documentElementOffset:function(){return document.documentElement.offsetHeight},documentElementScroll:function(){return document.documentElement.scrollHeight},max:function(){return Math.max.apply(null,ye(Z))},min:function(){return Math.min.apply(null,ye(Z))},grow:function(){return Z.max()},lowestElement:function(){return Math.max(Z.bodyOffset()||Z.documentElementOffset(),ve("bottom",be()))},taggedElement:function(){return we("bottom","data-iframe-height")}},$={bodyScroll:function(){return document.body.scrollWidth},bodyOffset:function(){return document.body.offsetWidth},custom:function(){return W.width()},documentElementScroll:function(){return document.documentElement.scrollWidth},documentElementOffset:function(){return document.documentElement.offsetWidth},scroll:function(){return Math.max($.bodyScroll(),$.documentElementScroll())},max:function(){return Math.max.apply(null,ye($))},min:function(){return Math.min.apply(null,ye($))},rightMostElement:function(){return ve("right",be())},taggedElement:function(){return we("right","data-iframe-width")}},_=(V=Te,Q=null,G=0,function(){var e=Date.now(),t=L-(e-(G=G||e));return X=this,Y=arguments,t<=0||L<t?(Q&&(clearTimeout(Q),Q=null),G=e,K=V.apply(X,Y),Q||(X=Y=null)):Q=Q||setTimeout(Ee,t),K});te(window,"message",function(t){var n={init:function(){y=t.data,z=t.source,ae(),h=!1,setTimeout(function(){v=!1},m)},reset:function(){v?ie("Page reset ignored by init"):(ie("Page size reset by host page"),Me("resetPage"))},resize:function(){Oe("resizeParent","Parent window requested size check")},moveToAnchor:function(){w.findTarget(i())},inPageLink:function(){this.moveToAnchor()},pageInfo:function(){var e=i();ie("PageInfoFromParent called from parent: "+e),H(JSON.parse(e)),ie(" --")},message:function(){var e=i();ie("onMessage called from parent: "+e),j(JSON.parse(e)),ie(" --")}};function o(){return t.data.split("]")[1].split(":")[0]}function i(){return t.data.substr(t.data.indexOf(":")+1)}function r(){return t.data.split(":")[2]in{true:1,false:1}}function e(){var e=o();e in n?n[e]():("undefined"==typeof module||!module.exports)&&"iFrameResize"in window||"jQuery"in window&&"iFrameResize"in window.jQuery.prototype||r()||re("Unexpected message ("+t.data+")")}S===(""+t.data).substr(0,M)&&(!1===h?e():r()?n.init():ie(\'Ignored message of type "\'+o()+\'". Received before initialization.\'))}),te(window,"readystatechange",Ae),Ae()}function ee(){}function te(e,t,n,o){e.addEventListener(t,n,!!J&&(o||{}))}function ne(e){return e.charAt(0).toUpperCase()+e.slice(1)}function oe(e){return S+"["+I+"] "+e}function ie(e){E&&"object"==typeof window.console&&console.log(oe(e))}function re(e){"object"==typeof window.console&&console.warn(oe(e))}function ae(){function e(e){return"true"===e}var t;function n(e){Ne(0,0,e.type,e.screenY+":"+e.screenX)}function o(e,t){ie("Add event listener: "+t),te(window.document,e,n)}t=y.substr(M).split(":"),I=t[0],a=c!==t[1]?Number(t[1]):a,l=c!==t[2]?e(t[2]):l,E=c!==t[3]?e(t[3]):E,b=c!==t[4]?Number(t[4]):b,i=c!==t[6]?e(t[6]):i,u=t[7],p=c!==t[8]?t[8]:p,r=t[9],d=t[10],R=c!==t[11]?Number(t[11]):R,w.enable=c!==t[12]&&e(t[12]),A=c!==t[13]?t[13]:A,P=c!==t[14]?t[14]:P,O=c!==t[15]?Boolean(t[15]):O,ie("Initialising iFrame ("+window.location.href+")"),function(){function e(e,t){return"function"==typeof e&&(ie("Setup custom "+t+"CalcMethod"),W[t]=e,e="custom"),e}"iFrameResizer"in window&&Object===window.iFrameResizer.constructor&&(function(){var e=window.iFrameResizer;ie("Reading data from page: "+JSON.stringify(e)),Object.keys(e).forEach(ue,e),j="onMessage"in e?e.onMessage:j,q="onReady"in e?e.onReady:q,k="targetOrigin"in e?e.targetOrigin:k,p="heightCalculationMethod"in e?e.heightCalculationMethod:p,P="widthCalculationMethod"in e?e.widthCalculationMethod:P}(),p=e(p,"height"),P=e(P,"width"));ie("TargetOrigin for parent set to: "+k)}(),function(){c===u&&(u=a+"px");ce("margin",function(e,t){-1!==t.indexOf("-")&&(re("Negative CSS value ignored for "+e),t="");return t}("margin",u))}(),ce("background",r),ce("padding",d),(t=document.createElement("div")).style.clear="both",t.style.display="block",t.style.height="0",document.body.appendChild(t),fe(),me(),document.documentElement.style.height="",document.body.style.height="",ie(\'HTML & body height set to "auto"\'),ie("Enable public methods"),D.parentIFrame={autoResize:function(e){return!0===e&&!1===i?(i=!0,he()):!1===e&&!0===i&&(i=!1,de("remove"),null!==s&&s.disconnect(),clearInterval(T)),Ne(0,0,"autoResize",JSON.stringify(i)),i},close:function(){Ne(0,0,"close")},getId:function(){return I},getPageInfo:function(e){"function"==typeof e?(H=e,Ne(0,0,"pageInfo")):(H=function(){},Ne(0,0,"pageInfoStop"))},moveToAnchor:function(e){w.findTarget(e)},reset:function(){Ie("parentIFrame.reset")},scrollTo:function(e,t){Ne(t,e,"scrollTo")},scrollToOffset:function(e,t){Ne(t,e,"scrollToOffset")},sendMessage:function(e,t){Ne(0,0,"message",JSON.stringify(e),t)},setHeightCalculationMethod:function(e){p=e,fe()},setWidthCalculationMethod:function(e){P=e,me()},setTargetOrigin:function(e){ie("Set targetOrigin: "+e),k=e},size:function(e,t){Oe("size","parentIFrame.size("+((e||"")+(t?","+t:""))+")",e,t)}},!0===O&&(o("mouseenter","Mouse Enter"),o("mouseleave","Mouse Leave")),he(),w=function(){function i(e){var t=e.getBoundingClientRect(),e={x:window.pageXOffset!==c?window.pageXOffset:document.documentElement.scrollLeft,y:window.pageYOffset!==c?window.pageYOffset:document.documentElement.scrollTop};return{x:parseInt(t.left,10)+parseInt(e.x,10),y:parseInt(t.top,10)+parseInt(e.y,10)}}function n(e){var t,n=e.split("#")[1]||e,e=decodeURIComponent(n),o=document.getElementById(e)||document.getElementsByName(e)[0];c!==o?(t=i(t=o),ie("Moving to in page link (#"+n+") at x: "+t.x+" y: "+t.y),Ne(t.y,t.x,"scrollToOffset")):(ie("In page link (#"+n+") not found in iFrame, so sending to parent"),Ne(0,0,"inPageLink","#"+n))}function e(){var e=window.location.hash,t=window.location.href;""!==e&&"#"!==e&&n(t)}function t(){Array.prototype.forEach.call(document.querySelectorAll(\'a[href^="#"]\'),function(e){"#"!==e.getAttribute("href")&&te(e,"click",function(e){e.preventDefault(),n(this.getAttribute("href"))})})}function o(){Array.prototype.forEach&&document.querySelectorAll?(ie("Setting up location.hash handlers"),t(),te(window,"hashchange",e),setTimeout(e,m)):re("In page linking not fully supported in this browser! (See README.md for IE8 workaround)")}w.enable?o():ie("In page linking not enabled");return{findTarget:n}}(),Oe("init","Init message from host page"),q()}function ue(e){var t=e.split("Callback");2===t.length&&(this[t="on"+t[0].charAt(0).toUpperCase()+t[0].slice(1)]=this[e],delete this[e],re("Deprecated: \'"+e+"\' has been renamed \'"+t+"\'. The old method will be removed in the next major version."))}function ce(e,t){c!==t&&""!==t&&"null"!==t&&ie("Body "+e+\' set to "\'+(document.body.style[e]=t)+\'"\')}function se(n){var e={add:function(e){function t(){Oe(n.eventName,n.eventType)}B[e]=t,te(window,e,t,{passive:!0})},remove:function(e){var t,n=B[e];delete B[e],t=window,e=e,n=n,t.removeEventListener(e,n,!1)}};n.eventNames&&Array.prototype.map?(n.eventName=n.eventNames[0],n.eventNames.map(e[n.method])):e[n.method](n.eventName),ie(ne(n.method)+" event listener: "+n.eventType)}function de(e){se({method:e,eventType:"Animation Start",eventNames:["animationstart","webkitAnimationStart"]}),se({method:e,eventType:"Animation Iteration",eventNames:["animationiteration","webkitAnimationIteration"]}),se({method:e,eventType:"Animation End",eventNames:["animationend","webkitAnimationEnd"]}),se({method:e,eventType:"Input",eventName:"input"}),se({method:e,eventType:"Mouse Up",eventName:"mouseup"}),se({method:e,eventType:"Mouse Down",eventName:"mousedown"}),se({method:e,eventType:"Orientation Change",eventName:"orientationchange"}),se({method:e,eventType:"Print",eventName:["afterprint","beforeprint"]}),se({method:e,eventType:"Ready State Change",eventName:"readystatechange"}),se({method:e,eventType:"Touch Start",eventName:"touchstart"}),se({method:e,eventType:"Touch End",eventName:"touchend"}),se({method:e,eventType:"Touch Cancel",eventName:"touchcancel"}),se({method:e,eventType:"Transition Start",eventNames:["transitionstart","webkitTransitionStart","MSTransitionStart","oTransitionStart","otransitionstart"]}),se({method:e,eventType:"Transition Iteration",eventNames:["transitioniteration","webkitTransitionIteration","MSTransitionIteration","oTransitionIteration","otransitioniteration"]}),se({method:e,eventType:"Transition End",eventNames:["transitionend","webkitTransitionEnd","MSTransitionEnd","oTransitionEnd","otransitionend"]}),"child"===A&&se({method:e,eventType:"IFrame Resized",eventName:"resize"})}function le(e,t,n,o){return t!==e&&(e in n||(re(e+" is not a valid option for "+o+"CalculationMethod."),e=t),ie(o+\' calculation method set to "\'+e+\'"\')),e}function fe(){p=le(p,n,Z,"height")}function me(){P=le(P,t,$,"width")}function he(){var e;!0===i?(de("add"),e=b<0,window.MutationObserver||window.WebKitMutationObserver?e?ge():s=function(){function t(e){function t(e){!1===e.complete&&(ie("Attach listeners to "+e.src),e.addEventListener("load",i,!1),e.addEventListener("error",r,!1),u.push(e))}"attributes"===e.type&&"src"===e.attributeName?t(e.target):"childList"===e.type&&Array.prototype.forEach.call(e.target.querySelectorAll("img"),t)}function o(e){ie("Remove listeners from "+e.src),e.removeEventListener("load",i,!1),e.removeEventListener("error",r,!1),e=e,u.splice(u.indexOf(e),1)}function n(e,t,n){o(e.target),Oe(t,n+": "+e.target.src)}function i(e){n(e,"imageLoad","Image loaded")}function r(e){n(e,"imageLoadFailed","Image load failed")}function a(e){Oe("mutationObserver","mutationObserver: "+e[0].target+" "+e[0].type),e.forEach(t)}var u=[],c=window.MutationObserver||window.WebKitMutationObserver,s=function(){var e=document.querySelector("body");return s=new c(a),ie("Create body MutationObserver"),s.observe(e,{attributes:!0,attributeOldValue:!1,characterData:!0,characterDataOldValue:!1,childList:!0,subtree:!0}),s}();return{disconnect:function(){"disconnect"in s&&(ie("Disconnect body MutationObserver"),s.disconnect(),u.forEach(o))}}}():(ie("MutationObserver not supported in this browser!"),ge())):ie("Auto Resize disabled")}function ge(){0!==b&&(ie("setInterval: "+b+"ms"),T=setInterval(function(){Oe("interval","setInterval: "+b)},Math.abs(b)))}function pe(e,t){var n=0;return t=t||document.body,n=null!==(n=document.defaultView.getComputedStyle(t,null))?n[e]:0,parseInt(n,o)}function ve(e,t){for(var n,o=t.length,i=0,r=ne(e),a=Date.now(),u=0;u<o;u++)i<(n=t[u].getBoundingClientRect()[e]+pe("margin"+r,t[u]))&&(i=n);return a=Date.now()-a,ie("Parsed "+o+" HTML elements"),ie("Element position calculated in "+a+"ms"),L/2<(a=a)&&ie("Event throttle increased to "+(L=2*a)+"ms"),i}function ye(e){return[e.bodyOffset(),e.bodyScroll(),e.documentElementOffset(),e.documentElementScroll()]}function we(e,t){var n=document.querySelectorAll("["+t+"]");return 0===n.length&&(re("No tagged elements ("+t+") found on page"),document.querySelectorAll("body *")),ve(e,n)}function be(){return document.querySelectorAll("body *")}function Te(e,t,n,o){function i(){e in{init:1,interval:1,size:1}||!(p in N||l&&P in N)?e in{interval:1}||ie("No change in size detected"):Ie(t)}var r,a;function u(e,t){return!(Math.abs(e-t)<=R)}r=c!==n?n:Z[p](),a=c!==o?o:$[P](),u(g,r)||l&&u(F,a)||"init"===e?(Se(),Ne(g=r,F=a,e)):i()}function Ee(){G=Date.now(),Q=null,K=V.apply(X,Y),Q||(X=Y=null)}function Oe(e,t,n,o){x&&e in f?ie("Trigger event cancelled: "+e):(e in{reset:1,resetPage:1,init:1}||ie("Trigger event: "+t),("init"===e?Te:_)(e,t,n,o))}function Se(){x||(x=!0,ie("Trigger event lock on")),clearTimeout(e),e=setTimeout(function(){x=!1,ie("Trigger event lock off"),ie("--")},m)}function Me(e){g=Z[p](),F=$[P](),Ne(g,F,e)}function Ie(e){var t=p;p=n,ie("Reset trigger event: "+e),Se(),Me("reset"),p=t}function Ne(e,t,n,o,i){var r;!0===C&&(c===i?i=k:ie("Message targetOrigin: "+i),ie("Sending message to host page ("+(r=I+":"+(e+":"+t)+":"+n+(c!==o?":"+o:""))+")"),z.postMessage(S+r,i))}function Ae(){"loading"!==document.readyState&&window.parent.postMessage("[iFrameResizerChild]Ready","*")}}();\n//# sourceMappingURL=iframeResizer.contentWindow.map'
            }
        },
        r = {};

    function o(e) {
        var t = r[e];
        if (void 0 !== t) return t.exports;
        var i = r[e] = {
            id: e,
            exports: {}
        };
        return n[e].call(i.exports, i, i.exports, o), i.exports
    }
    o.m = n, o.n = e => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return o.d(t, {
            a: t
        }), t
    }, o.d = (e, t) => {
        for (var n in t) o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
        })
    }, o.f = {}, o.e = e => Promise.all(Object.keys(o.f).reduce(((t, n) => (o.f[n](e, t), t)), [])), o.u = e => e + ".js", o.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")()
        } catch (e) {
            if ("object" == typeof window) return window
        }
    }(), o.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), e = {}, t = "@podlove/web-player:", o.l = (n, r, i, a) => {
        if (e[n]) e[n].push(r);
        else {
            var u, c;
            if (void 0 !== i)
                for (var s = document.getElementsByTagName("script"), l = 0; l < s.length; l++) {
                    var f = s[l];
                    if (f.getAttribute("src") == n || f.getAttribute("data-webpack") == t + i) {
                        u = f;
                        break
                    }
                }
            u || (c = !0, (u = document.createElement("script")).charset = "utf-8", u.timeout = 120, o.nc && u.setAttribute("nonce", o.nc), u.setAttribute("data-webpack", t + i), u.src = n), e[n] = [r];
            var d = (t, r) => {
                    u.onerror = u.onload = null, clearTimeout(p);
                    var o = e[n];
                    if (delete e[n], u.parentNode && u.parentNode.removeChild(u), o && o.forEach((e => e(r))), t) return t(r)
                },
                p = setTimeout(d.bind(null, void 0, {
                    type: "timeout",
                    target: u
                }), 12e4);
            u.onerror = d.bind(null, u.onerror), u.onload = d.bind(null, u.onload), c && document.head.appendChild(u)
        }
    }, o.r = e => {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }, (() => {
        var e;
        o.g.importScripts && (e = o.g.location + "");
        var t = o.g.document;
        if (!e && t && (t.currentScript && (e = t.currentScript.src), !e)) {
            var n = t.getElementsByTagName("script");
            n.length && (e = n[n.length - 1].src)
        }
        if (!e) throw new Error("Automatic publicPath is not supported in this browser");
        e = e.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), o.p = e
    })(), (() => {
        var e = {
            embed: 0
        };
        o.f.j = (t, n) => {
            var r = o.o(e, t) ? e[t] : void 0;
            if (0 !== r)
                if (r) n.push(r[2]);
                else {
                    var i = new Promise(((n, o) => r = e[t] = [n, o]));
                    n.push(r[2] = i);
                    var a = o.p + o.u(t),
                        u = new Error;
                    o.l(a, (n => {
                        if (o.o(e, t) && (0 !== (r = e[t]) && (e[t] = void 0), r)) {
                            var i = n && ("load" === n.type ? "missing" : n.type),
                                a = n && n.target && n.target.src;
                            u.message = "Loading chunk " + t + " failed.\n(" + i + ": " + a + ")", u.name = "ChunkLoadError", u.type = i, u.request = a, r[1](u)
                        }
                    }), "chunk-" + t, t)
                }
        };
        var t = (t, n) => {
                var r, i, [a, u, c] = n,
                    s = 0;
                for (r in u) o.o(u, r) && (o.m[r] = u[r]);
                for (c && c(o), t && t(n); s < a.length; s++) i = a[s], o.o(e, i) && e[i] && e[i][0](), e[a[s]] = 0
            },
            n = self.webpackChunk_podlove_web_player = self.webpackChunk_podlove_web_player || [];
        n.forEach(t.bind(null, 0)), n.push = t.bind(null, n.push.bind(n))
    })(), o("./src/embed.js")
})();